/* GENERATED by build/make_theme.py from public/app.js — DO NOT EDIT IN THE THEME.
   Edit the prototype and re-run the generator, or the two drift apart. */
var SF_BASE = window.SF_BASE || 'https://artwork.boatmat.com/sportfish/';
/* =====================================================================
   SPORTFISH DESIGN STATION — prototype engine (revised build)
   Boat Mat Corporation. Internal review build. NOT LIVE.

   Product data (sizes, Sunbrella colors, thread colors, HD DigiPrint
   palette, boarding-mat photography) comes from the LIVE BoatMat theme:
     sections/custom-boarding-mats.liquid
     sections/custom-dock-mats.liquid
   The HD DigiPrint gallery comes from BoatMat's own proof wall.
   Nothing here is invented.

   The scene is projected through the SAME physically correct camera that
   rendered assets/scene-bg.jpg (build/scene.py -> scene-cam.json), so the
   30/40in boarding mats and the 60in HD mat are in true relative
   proportion and cannot drift.
   ===================================================================== */

/* ------------------------------------------------------------------ *
 * 1. PRODUCT DATA
 * ------------------------------------------------------------------ */

var BOARD_LEN = 33;                    /* every boarding mat is 33in across the rail */
/* RULE (Patrick, 2026-09-07, no exceptions): the embroidery ALWAYS goes on the TOP
   FACE — the surface people step on as they board — never the outboard drape.
   Every artwork calculation is locked to the 12in top zone below. Do not move it. */
var Z_TOP_A = 10, Z_TOP_B = 22;        /* 10in inboard | 12in top | 11in outboard */
var TOP_DEEP = Z_TOP_B - Z_TOP_A;      /* 12 */
var DRAPE_DEEP = BOARD_LEN - Z_TOP_B;  /* 11 */
var SANDBAG_IN = 3.0;                  /* sandbag pocket depth at each end */

/* RULE (Patrick, 2026-09-07): every Sportfish package ships the SAME 3ft x 5ft HD
   DigiPrint mat — 36in x 60in. Not 3x4, not 4x6. The packages differ ONLY by
   boarding mat width. Do not reintroduce alternative dock sizes. */
var DOCK_MAT  = [60, 36];              /* width x depth, inches */
var DOCK_LABEL = "3′ × 5′";
var DOCK_NAME  = "HD DigiPrint™ Mat";
/* The Step 1 cards word it the way Patrick wrote it on 2026-09-08:
   "Matching 5′ × 3′ HD DigiPrint™ Dock Mat". Same mat, same 36″ × 60″ — his own wording
   on the package descriptions, with DOCK_LABEL/DOCK_NAME left alone everywhere else
   (the preview caption and the order summary still read 3′ × 5′ HD DigiPrint™ Mat). */
var CARD_DOCK_LINE = "Matching 5′ × 3′ HD DigiPrint™ Dock Mat";

/* TWO packages (Patrick, 2026-09-08, final: "this is the package page only and I only
   want 30 and 40 inch packages"). The 20in / Small Sportfish package is DELETED, not
   hidden or disabled — same standard as his 2026-09-07 removal instruction.

   Complete package deals: the price on the card is the whole package. There is NO
   separate artwork charge and NO separate $150 logo digitizing charge — both are
   included — and there is no crossed-out "regular value" or Save $ badge, because
   inventing a saving off a component list is exactly the kind of number Patrick does
   not want on the page. Prices are the ones he last approved (2026-09-08 00:36); only
   the package COUNT changed here, not the pricing.

   Only the Boarding Mat width changes between packages. The HD DigiPrint mat is
   3′ × 5′ in both.

   `sku` is the Shopify product/variant this package maps to. The payable amount comes
   from that variant server-side — `price` here is display only and is never the
   authority for what a customer is charged. */
/* `vessels` is the boat length the package is FOR — Patrick, 2026-09-08. It is the first
   thing a captain matches themselves against, so it is displayed directly under the
   package name, not buried in the bullet list. Prices and dimensions are unchanged. */
/* NEITHER PACKAGE IS FAVORED (Patrick, 2026-09-08): "Remove Most Popular and STANDARD
   SPORTFISH. Do not favor one package over the other. They are both valid and popular
   packages. The choice comes down to the correct Boarding Mat size for the vessel."
   So the `popular` flag is DELETED — nothing in the data can badge a card again — and
   the names are the two sizes themselves. STANDARD / LARGE (and SMALL before them) are
   dead: a name that ranks the packages is exactly what he removed. Prices, sizes and
   SKUs are untouched. */
var PACKAGES = [
  { key:'30', name:'30″ Sportfish', board:30, price:'$499.95', priceNum:499.95,
    vessels:'Recommended for Boats 30′–50′',       sku:'SPORTFISH-PKG-30' },
  { key:'40', name:'40″ Sportfish', board:40, price:'$599.95', priceNum:599.95,
    vessels:'Recommended for Boats 50′ and Above', sku:'SPORTFISH-PKG-40' }
];

/* A non-stock Sunbrella color is sourced to order and carries a real upcharge — the
   same $35/mat the live boarding-mat configurator charges. */
var SPECIALTY_UPCHARGE = 35.00;

/* ---- PACKAGE COLOR ------------------------------------------------
   Both products are made in ONE base color so the package is coordinated.
   The Sunbrella SeaMark colors are the real constraint (four are stocked),
   so they drive the package color; `hd` is the coordinated HD DigiPrint
   base and `bind` its matching binding.

   HD_SOURCE records where the HD colors come from — now 'chart', i.e. Patrick's own
   printed reference, cut up by build/hd_swatches.py.                       */
/* Both products now show the REAL material, not a hex approximation of it (Patrick,
   2026-09-07: "I want the real chart used and not the hex colors ... same thing with
   the sunbrella .. I want the actual swatch used").

   Boarding mat  -> the Sunbrella swatch PHOTOGRAPH, pixels untouched.
   HD mat        -> a crop cut straight out of Patrick's printed color chart.

   Every hex below survives only as a one-frame fallback while its image loads, and as
   the fill behind the binding.  `hdCell` names the real chart cell the HD mat is made
   in, and its PMS number is read off the chart by build/hd_swatches.py — so the UI can
   always tell the customer exactly which printed color they are looking at.        */
/* THE SIX STOCKED BOARDING MAT COLORS (Patrick, 2026-09-08), in his order.
   `seamark` records the real Sunbrella SeaMark colorway each plate is, so a swatch can
   never quietly drift onto the wrong fabric.

   Five plates are BoatMat's own studio photographs of the fabric. Pacific Blue is the
   one color BoatMat has never photographed, so its plate is cut from Glen Raven's own
   SeaMark 2108-0063 swatch and rescaled to BoatMat's weave pitch — the cross-check is
   SeaMark Navy: Glen Raven's plate averages rgb(39,41,52) and BoatMat's own averages
   rgb(38,40,51), i.e. the two sources agree on the same fabric to within a point.
   Swap in a BoatMat studio shot when one exists; it is a file replacement, no code. */
var HD_SOURCE = 'chart';
/* `fab` is the MEASURED mean of that plate, used only as the one-frame fill while the
   photograph loads. `seamark` is filled in only where the colorway was actually
   verified against Glen Raven's own reference swatch — never guessed. */
/* `target` IS THE PRODUCT COLOR, AND IT IS SOURCED — NOT A DEMO VALUE.
   Patrick, 2026-09-08: "LIGHT GRAY MUST LOOK LIGHT GRAY. It must NOT look beige, tan,
   brown, or warm cream … Do not simply reuse whatever CSS color values happen to be in
   the prototype. Do not use demo color values. Find the actual intended BoatMat product
   colors and calibrate the Design Station preview from those."

   THE SOURCE is BoatMat.com's own live boarding-mat configurator —
   `sections/custom-boarding-mats.liquid` — which is what a customer is sold today:
     quickPick(), the one table on that page that names all five the way this page does:
       black #1A1A18 · navy #0D2148 "Navy Blue" · charcoal #484848 "Charcoal Gray" ·
       lightgray #BEBEBE "Light Gray" · tan #C8A870 "Tan"
     pickSunbrella(), the standard-color selector, plus the swatch map and the page's
     default state, all of which use #0d2b52 for Navy.
   Navy therefore takes #0d2b52 (three places on the live page, and the same navy this
   station already uses for Navy thread) rather than quickPick's #0D2148 — the two are
   within a couple of ΔE of each other and both read as navy. The three neutrals come
   from quickPick, which is the only place the live site distinguishes Charcoal Gray
   from Light Gray, and its ramp is internally consistent: 1A/48/BE.
   Pacific Blue is not a standard color on the live site (it is listed there as an
   example of a SPECIALTY color), so its target is the manufacturer's own reference:
   Glen Raven SeaMark Pacific Blue 2108-0063, measured rgb(5,87,158).

   `fab` — the mean of the studio PHOTOGRAPH — is kept, and it is why this exists. Those
   plates are what was rendering before, and three of them are nowhere near the product
   color they are labelled with:
        Light Gray     photo #B5A99A (181,169,154)  vs product #BEBEBE  <- warm greige
        Charcoal Gray  photo #64615B (100,97,91)    vs product #484848  <- light + warm
        Tan            photo #DFC69C (223,198,156)  vs product #C8A870
   The photograph now supplies the WEAVE only; `target` supplies the COLOR. See 5c. */
var PACK_COLORS = [
  { k:'navy',          n:'Navy',          seamark:'SeaMark Navy 2107-0063',
    target:'#0d2b52',
    fab:'#262833', img:SF_BASE+'assets/sunbrella-swatch-navy.jpg',          hdCell:'N1'  },
  { k:'charcoal-gray', n:'Charcoal Gray', seamark:'SeaMark Charcoal Grey 2110-0063',
    target:'#484848',
    fab:'#64615B', img:SF_BASE+'assets/sunbrella-swatch-charcoal-gray.jpg', hdCell:'O8'  },
  { k:'light-gray',    n:'Light Gray',    seamark:'SeaMark Cadet Grey 2097-0063',
    target:'#BEBEBE',
    fab:'#B5A99A', img:SF_BASE+'assets/sunbrella-swatch-light-gray.jpg',    hdCell:'N10' },
  { k:'black',         n:'Black',         seamark:'',
    target:'#1A1A18',
    fab:'#1B1914', img:SF_BASE+'assets/sunbrella-swatch-black.jpg',         hdCell:'O6'  },
  { k:'tan',           n:'Tan',           seamark:'',
    target:'#C8A870',
    fab:'#DFC69C', img:SF_BASE+'assets/sunbrella-swatch-tan.jpg',           hdCell:'F4'  },
  { k:'pacific-blue',  n:'Pacific Blue',  seamark:'SeaMark Pacific Blue 2108-0063',
    target:'#05579E',
    fab:'#05579E', img:SF_BASE+'assets/sunbrella-swatch-pacific-blue.jpg',  hdCell:'L1'  }
];
/* Resolve each package color to its real chart swatch: the tile image the mat is
   painted with, and the PMS name printed under that swatch. To move a package onto a
   different printed color, change `hdCell` above to any cell A1..O10 — nothing else. */
var HD_BY_CELL = {};
(function applyChartColors(){
  var byCell = HD_BY_CELL;
  HD_COLORS.forEach(function(c){ byCell[c.c] = c; });
  PACK_COLORS.forEach(function(c){
    var ref = byCell[c.hdCell] || {};
    c.swatch = SF_BASE+'assets/hd-tile-' + c.hdCell + '.jpg';
    c.hd     = ref.h || c.fab;          /* fallback fill only */
    c.bind   = shade(c.hd, 0.72);       /* binding is the same material, in shadow */
    c.hdName = ref.n || '';             /* e.g. "PMS 648" — never invented */
  });
})();

/* The 8 standard embroidery thread colors carried by the live boarding-mat
   configurator. These are the LETTERING thread choices — the color a vessel name or
   line of text is sewn in.

   They are NOT the palette an uploaded logo is reduced to. That is the correction
   Patrick asked for on 2026-09-08: an earlier build quantized an uploaded logo into
   these eight, which turned the red in the BoatMat logo into TAN, so the same logo
   read as two different sets of colors on the two mats. Logo digitizing is included
   in every package and the threads are matched to the artwork when it is digitized,
   so the honest preview keeps the logo's own colors on both products. */
/* ORDER MATTERS — no two look-alikes side by side (Patrick, 2026-09-08): "Do not put
   similar-looking colors directly next to each other. Especially: do NOT place Yellow
   directly next to Gold."

   RED and ROYAL BLUE were added in the same brief and nothing was dropped — Silver and
   Tan are still offered. That makes TEN tiles, which lay out 5 x 2 on a desktop and
   2 x 5 on a phone, so "next to each other" is not only the reading order: tile i also
   touches i+1, i+2 (the phone's row below) and i+5 (the desktop's row below). This
   order is the one ordering that keeps every look-alike pair — Gold/Yellow/Tan,
   White/Silver/Gray, Navy/Royal Blue and Navy/Black — out of all three of those
   distances at once while staying as close as it can to the sequence Patrick wrote out.
   It is not arbitrary: re-order it by eye and Gold lands directly under Yellow on one
   viewport or the other. The 5- and 2-column grids in the stylesheet are part of the
   same guarantee — do not add a 3- or 4-column breakpoint without re-solving this. */
var THREADS = [
  {n:'Navy',       hex:'#0d2b52'},
  {n:'White',      hex:'#f0f0f0'},
  {n:'Red',        hex:'#C8102E'},
  {n:'Gold',       hex:'#f5bc2f'},
  {n:'Royal Blue', hex:'#2952CC'},
  {n:'Gray',       hex:'#808080'},
  {n:'Yellow',     hex:'#FFD700'},
  {n:'Black',      hex:'#1a1a18'},
  {n:'Silver',     hex:'#C0C0C0'},
  {n:'Tan',        hex:'#C8A870'}
];
/* The page has always OPENED on Gold thread. That is a starting appearance, not a
   ranking, so it survives the reorder by name instead of by index — THREADS[0] is Navy
   now, and picking up the first element would have silently changed the default. */
function threadByName(n){
  for(var i=0;i<THREADS.length;i++) if(THREADS[i].n===n) return THREADS[i];
  return THREADS[0];
}

var FONTS = [
  {k:'bebas',  n:'Block Bold',  css:"'Bebas Neue',sans-serif",       up:true,  w:'400'},
  {k:'cond',   n:'Sport Cond.', css:"'Barlow Condensed',sans-serif", up:true,  w:'700'},
  {k:'serif',  n:'Naval Serif', css:"Georgia,serif",                 up:true,  w:'700'},
  {k:'script', n:'Script',      css:"Georgia,serif",                 up:false, w:'700', it:true},
  {k:'brush',  n:'Brush',       css:"'Dancing Script',cursive",      up:false, w:'700'},
  {k:'russ',   n:'Russ Times',  css:"'Playfair Display',serif",      up:false, w:'700', it:true}
];

/* Real completed BoatMat boarding mats — boarding mats only, no deck/dock mats.
   The list, the numbering and the thumbnails are built by build/make_board_gallery.py
   into gallery-board.json; nothing here sorts or shuffles, so #12 is the same
   photograph on every load and for every customer. */
var HD_GAL_FULL = 'https://artwork.boatmat.com/art/';   /* full-size, already published */

/* ------------------------------------------------------------------ *
 * 2. SCENE CAMERA — loaded from scene-cam.json (written by build/scene.py)
 * ------------------------------------------------------------------ */
var CAM = null, WLD = null, IMG_W = 1600, IMG_H = 1150;

function proj(X, Y, Z){
  var vx = X - CAM.C[0], vy = Y - CAM.C[1], vz = Z - CAM.C[2];
  var d  = vx*CAM.f[0] + vy*CAM.f[1] + vz*CAM.f[2];
  var xc = vx*CAM.r[0] + vy*CAM.r[1] + vz*CAM.r[2];
  var yc = vx*CAM.u[0] + vy*CAM.u[1] + vz*CAM.u[2];
  return [CAM.cx + CAM.F*xc/d, CAM.cy - CAM.F*yc/d];
}
/* mat geometry in the scene, derived once from the world constants */
function G(){
  var t = WLD.mat_thick;
  return {
    y0: WLD.hull_y - t,                       /* the fold, just proud of the topside */
    y1: WLD.hull_y - t + TOP_DEEP,            /* inboard edge of the top face        */
    z:  WLD.gunwale_z + t,                    /* mat lies on the covering board      */
    zb: WLD.gunwale_z + t - DRAPE_DEEP        /* bottom of the outboard drape        */
  };
}
/* canvas (0,0)(W,0)(W,H)(0,H) -> scene pixels */
function dockQuad(){
  var hw = DOCK_MAT[0]/2, yf = WLD.dock_mat_far, yn = WLD.dock_mat_near;
  return [proj(-hw,yf,0), proj(hw,yf,0), proj(hw,yn,0), proj(-hw,yn,0)];
}
function boardTopQuad(w){
  var g = G(), h = w/2;
  return [proj(-h,g.y1,g.z), proj(h,g.y1,g.z), proj(h,g.y0,g.z), proj(-h,g.y0,g.z)];
}
function boardDrapeQuad(w){
  var g = G(), h = w/2;
  return [proj(-h,g.y0,g.z), proj(h,g.y0,g.z), proj(h,g.y0,g.zb), proj(-h,g.y0,g.zb)];
}
/* soft shadows, cast onto the plane the product sits on */
function dockShadowQuad(){
  var hw = DOCK_MAT[0]/2 + 4, yf = WLD.dock_mat_far + 3.4, yn = WLD.dock_mat_near - 4.6;
  return [proj(-hw,yf,0), proj(hw,yf,0), proj(hw,yn,0), proj(-hw,yn,0)];
}
function drapeShadowQuad(w){
  var g = G(), h = w/2 + 2.2, y = WLD.hull_y;
  return [proj(-h,y,g.z), proj(h,y,g.z), proj(h,y,g.zb-3.0), proj(-h,y,g.zb-3.0)];
}
function topShadowQuad(w){
  var g = G(), h = w/2 + 2.6;
  return [proj(-h,g.y1+2.4,WLD.gunwale_z), proj(h,g.y1+2.4,WLD.gunwale_z),
          proj(h,g.y0,WLD.gunwale_z),      proj(-h,g.y0,WLD.gunwale_z)];
}

/* ------------------------------------------------------------------ *
 * 3. SAFE AREAS — inches, calculated INDEPENDENTLY per product
 * ------------------------------------------------------------------ */
var B_INSET_X = 1.6, B_INSET_Y = 1.9;    /* inside the end binding / zone seams */
var D_INSET   = 2.5;                     /* inside the bound edge of the HD mat */

function boardSafe(){ return { w:S.boardW - B_INSET_X*2, h:TOP_DEEP - B_INSET_Y*2 }; }
function dockSafe(){  return { w:DOCK_MAT[0] - D_INSET*2, h:DOCK_MAT[1] - D_INSET*2 }; }
function safeOf(w){ return w==='board' ? boardSafe() : dockSafe(); }

/* ------------------------------------------------------------------ *
 * 4. STATE
 * ------------------------------------------------------------------ */
var DEFAULT_SCALE = 0.75;                /* THE RULE: 75% of usable width */
function newArt(){ return { xN:0.5, yN:0.5, sN:DEFAULT_SCALE, rot:0 }; }

/* COLOR MODEL (revised again 2026-09-08 — Patrick's second correction brief).
   FOUR separate ideas, four separate names, never mixed:

     color  -> BOARDING MAT COLOR.        The physical Sunbrella cloth. Six stocked
                                          colorways plus SPECIALTY (+$35/mat, sourced).
     thread -> EMBROIDERY THREAD COLOR.   What the lettering is sewn in.
     hd     -> HD MAT BACKGROUND COLOR.   The printed carpet itself, and its binding.
     ink    -> HD PRINT / INK COLOR.      What the artwork is printed in.

   `hd` and `ink` both come off the same 150-cell printed chart because both are
   genuinely printed, but NEITHER is chosen by the customer any more.

   MATCHING RULE (Patrick, 2026-09-08 — this replaces the old two-selector design).
   The package is a MATCHING SET, so there is exactly ONE color decision and it is made
   on the Boarding Mat. `hd` is derived from the Boarding Mat color and `ink` from the
   embroidery thread color, always, with no latch and no override — the HD Mat
   Background Color and HD Print / Ink Color chart boxes were removed from the page.
   A different HD color or a different design is a separate order, from the regular HD
   printed mat page. Do not reintroduce `hdTouched` / `inkTouched` or a chart selector. */
var S = {
  pkg:'30', boardW:30,
  /* not a mode and not a tab — just the mat the customer last touched in the preview,
     so a two-finger pinch knows which one to scale */
  edit:'board',
  mode:'text', vessel:'', font:FONTS[0],
  color:PACK_COLORS[3],                    /* BLACK — both products open black */
  specialty:false, specialtyName:'',
  hd:null,
  thread:threadByName('Gold'), threadRequest:'',
  ink:null,
  logo:{ img:null, ok:false, name:'', palette:[] },
  art:{ board:newArt(), dock:newArt() },
  /* order information that must survive every screen change (Patrick, items 14–15) */
  refBoard:null, refHd:null, notes:''
};

/* ------------------------------------------------------------------ *
 * 5. ASSET LOADING
 * ------------------------------------------------------------------ */
var MAPS = {}, FAB = {}, HDSW = {}, READY = false, pending = 1;
function done(){ if(--pending === 0){ READY = true; buildUI(); renderAll(); } }
function loadImg(src, cb){
  pending++;
  var im = new Image();
  /* CROSS-ORIGIN, DELIBERATELY. Inside the Shopify theme the page is served from
     www.boatmat.com and these plates come from artwork.boatmat.com. An image drawn into
     a canvas without CORS TAINTS that canvas, and every getImageData() call after it
     throws — which is silent here, because expose() and recolorTile() catch and return
     the tile unchanged. The visible symptom would be the colour calibration quietly
     dying: "Light Gray" back to tan. The host sends Access-Control-Allow-Origin for
     /sportfish/* (Caddy); this is the other half of that pair. Must be set BEFORE .src. */
  im.crossOrigin = 'anonymous';
  im.onload  = function(){ cb(im); done(); };
  im.onerror = function(){ done(); };
  im.src = src;
}
['btop','bdrape','dock'].forEach(function(n){
  MAPS[n] = {};
  loadImg(SF_BASE+'assets/'+n+'-mul.png', function(i){ MAPS[n].mul = i; });
  loadImg(SF_BASE+'assets/'+n+'-add.png', function(i){ MAPS[n].add = i; });
});
PACK_COLORS.forEach(function(c){
  loadImg(c.img, function(i){ FAB[c.k] = expose(mirrorTile(i, 0.45), DAYLIGHT); });
  /* The chart is a print reference, photographed correctly lit — it gets NO exposure
     change at all, so PMS 648 stays PMS 648. Only the dark studio swatch shots are
     lifted, and lifting the chart too turned navy into a royal blue. */
  if(c.swatch) loadImg(c.swatch, function(i){ HDSW[c.hdCell] = mirrorTile(i, 0.5); });
});

/* Every one of the 150 chart cells now has its own mat-surface tile
   (build/hd_swatches.py), because the HD DigiPrint mat can be ordered in any printed
   color. The four coordinated cells are preloaded above so the first paint is already
   the real material; the rest are fetched the moment they are chosen — about 9 KB each
   — and the color's own hex fills the mat for the single frame in between. */
var HD_PENDING = {};
function hdTile(){
  var code = S.hd && S.hd.c;
  if(!code) return null;
  if(HDSW[code]) return HDSW[code];
  if(!HD_PENDING[code]){
    HD_PENDING[code] = 1;
    var im = new Image();
    im.crossOrigin = 'anonymous';          /* same reason as loadImg() — canvas safety */
    im.onload = function(){ HDSW[code] = mirrorTile(im, 0.5); renderAll(); };
    im.src = SF_BASE+'assets/hd-tile-' + code + '.jpg';
  }
  return null;
}
/* the HD mat's binding is the same printed material as its face, turned from the light */
/* hdBind() painted the binding color onto the flat HD proof — that proof is gone. */

/* ================================================================== *
 * 5b. PACKAGE COLOR CALIBRATION — MAKING THE PAIR READ AS A SET
 *
 * Patrick, 2026-09-08: "the Boarding Mat color and the matching HD DigiPrint™ Dock Mat
 * color do not even look close to each other … they MUST look close enough that a
 * customer immediately sees them as a matching package … Use the Boarding Mat color as
 * the visual anchor, then adjust the HD DigiPrint™ Dock Mat preview so it reads as the
 * same intended color family. This is a PREVIEW calibration issue."
 *
 * MEASURED, before this existed (mean of the painted canvases, CIE76 ΔE):
 *     Navy          board #353744  HD #25335b   ΔE 18.2   <- slate vs royal blue
 *     Charcoal Gray board #7a7670  HD #5c5b59   ΔE 11.4   <- light gray vs dark gray
 *     Black         board #27251f  HD #0e0f13   ΔE 12.4   <- charcoal vs black
 *     Pacific Blue  board #096bb3  HD #1e509a   ΔE 13.2
 * i.e. three of Patrick's four named failure modes, on the page, at once.
 *
 * WHY IT HAPPENED — worth knowing before "fixing" it somewhere else. The Sunbrella
 * swatch photographs are under-exposed studio shots and get a daylight gamma lift
 * (DAYLIGHT, above); the HD chart crops are a correctly exposed print reference and
 * deliberately get NO lift. So the two materials were entering the scene under two
 * different exposures, and then each was multiplied by its OWN luminance map — the
 * boarding mat's vertical top face and the dock mat's flat plane carry different
 * lighting. Two different exposures times two different maps is the whole mismatch.
 *
 * WHAT THIS DOES: the Boarding Mat is the anchor. The HD tile keeps its own PRINT
 * TEXTURE and is moved, in color only, to the value that comes out of the scene
 * matching the boarding mat's painted color:
 *
 *     target_tile = board_tile_mean x  K(btop) / K(dock)
 *
 * K() is the gain the whole paint pipeline applies to a surface — measured, once, by
 * running a flat gray through paintSurface() itself rather than re-deriving the map
 * math here, so it cannot drift out of step with a change to the maps or the shading.
 * The move is split between a gain and an offset (g = sqrt(t/m)) so a dark color like
 * Black is not stretched 2.6x, which would amplify the carpet's grain into noise.
 *
 * WHAT IT DOES NOT DO — this is the constraint Patrick set:
 *   - it does NOT change S.hd, the chart cell, the PMS number, the color NAMES, or
 *     anything that reaches production. prodSpec() and cartSummary() are untouched:
 *     the mat is still made in the cell coordinate() picked. This is the PREVIEW only.
 *   - it does NOT touch the customer's artwork (drawArt paints after the shading), and
 *     it does NOT touch the Boarding Mat, which is the reference.
 * If the printed cell is ever a genuinely poor production match for a fabric, that is a
 * COLOR-CHOICE decision for Patrick — change `hdCell` in PACK_COLORS — not something to
 * hide by re-tinting a preview.
 * ================================================================== */
var SURF_K = {};                 /* mapName -> [kr,kg,kb], the pipeline's own gain */
var CAL_GRAY = 160;              /* mid gray: high enough to measure, far from clipping */
function surfaceK(mapName){
  if(SURF_K[mapName]) return SURF_K[mapName];
  var M = MAPS[mapName];
  if(!M || !M.mul || !M.add) return null;         /* maps not in yet — try again later */
  var cv = document.createElement('canvas');
  paintSurface(cv, mapName, 260, 150, function(c,W,H){
    c.fillStyle = 'rgb('+CAL_GRAY+','+CAL_GRAY+','+CAL_GRAY+')'; c.fillRect(0,0,W,H);
  }, null, 34);
  var m = meanRGBA(cv);
  if(!m) return null;
  SURF_K[mapName] = [m[0]/CAL_GRAY, m[1]/CAL_GRAY, m[2]/CAL_GRAY];
  return SURF_K[mapName];
}
/* mean of the pixels a surface actually covers — anything the silhouette masked out is
   transparent and must not drag the average toward zero */
function meanRGBA(cv){
  var c = cv.getContext('2d', {willReadFrequently:true}), d;
  try { d = c.getImageData(0,0,cv.width,cv.height); } catch(e){ return null; }
  var px = d.data, r=0,g=0,b=0,n=0, i;
  for(i=0;i<px.length;i+=4){
    if(px[i+3] < 250) continue;
    r+=px[i]; g+=px[i+1]; b+=px[i+2]; n++;
  }
  return n ? [r/n, g/n, b/n] : null;
}
var TILE_MEAN = {};              /* canvas -> mean, cached by the tile's own identity */
function tileMean(t, key){
  if(!t) return null;
  if(TILE_MEAN[key]) return TILE_MEAN[key];
  var m = meanRGBA(t);
  if(m) TILE_MEAN[key] = m;
  return m;
}
/* Move `tile` so its mean becomes `target`, keeping its texture. Split between a gain
   and an offset: a pure gain crushes or amplifies contrast when the move is large, a
   pure offset flattens the material's own shading. */
function recolorTile(tile, target, mean){
  var t = document.createElement('canvas');
  t.width = tile.width; t.height = tile.height;
  var c = t.getContext('2d', {willReadFrequently:true});
  c.drawImage(tile, 0, 0);
  var d;
  try { d = c.getImageData(0,0,t.width,t.height); } catch(e){ return tile; }
  var px = d.data, k, i, lut = [new Uint8Array(256), new Uint8Array(256), new Uint8Array(256)];
  for(k=0;k<3;k++){
    var m = Math.max(1, mean[k]), tg = Math.max(0, Math.min(255, target[k]));
    var g = Math.sqrt(tg/m);
    g = Math.max(0.45, Math.min(2.2, g));
    var off = tg - m*g;
    for(i=0;i<256;i++) lut[k][i] = Math.max(0, Math.min(255, Math.round(i*g + off)));
  }
  for(i=0;i<px.length;i+=4)
    for(k=0;k<3;k++) px[i+k] = lut[k][px[i+k]];
  c.putImageData(d,0,0);
  return t;
}
/* ================================================================== *
 * 5c. THE BOARDING MAT READS AS ITS OWN COLOR NAME
 *
 * Patrick, 2026-09-08: "LIGHT GRAY is rendering TAN in the Design Station preview. That
 * is unacceptable … If a texture layer is turning Light Gray into tan, FIX THE RENDERING
 * METHOD. Do not just rename the tan-looking color 'Light Gray.'"
 *
 * It was not a texture layer and it was not a blend mode. It was the SOURCE: the studio
 * photograph labelled light-gray is a warm greige — rgb(181,169,154), 27 points warmer in
 * red than in blue — and the daylight gamma then lifted it to rgb(201,189,176), which is
 * cream. Charcoal photographed at rgb(100,97,91), a mid warm gray, not charcoal at all.
 * Rendering those pixels faithfully is exactly what produced a tan "Light Gray".
 *
 * So the photograph now supplies the WEAVE and the product color supplies the COLOR:
 * each fabric tile is moved so that what the customer finally sees painted on the mat —
 * after the scene's own lighting — is the product color from PACK_COLORS[].target, which
 * is sourced from BoatMat.com's live configurator (see the note on PACK_COLORS).
 *
 *     target_tile = product_color / K(btop)
 *
 * K() is the gain the paint pipeline itself applies, measured by running a flat gray
 * through paintSurface() — the same mechanism the HD mat is anchored with, so a change
 * to the maps or the shading moves both together and the pair cannot drift apart.
 *
 * WHY THIS IS NOT THE OLD tintTile() PATRICK REJECTED: that one rescaled the photograph
 * onto a GUESSED catalogue hex and the target was invented. This target is a real product
 * value, read out of the live store, and Patrick's instruction here is explicitly to
 * calibrate from the intended product colors. The weave, its grain, its highlights and
 * its texture are all still the photographed material.
 * ================================================================== */
function hexToRGB(h){
  var m = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(h || '');
  return m ? [parseInt(m[1],16), parseInt(m[2],16), parseInt(m[3],16)] : null;
}
var FAB_CAL = {}, FAB_CHIP = {};
/* the calibrated fabric tile — the one thing every other surface reads the color from */
function fabTile(k){
  var raw = FAB[k];
  if(!raw) return null;
  var c = colorByKey(k), kB = surfaceK('btop'), tgt = c && hexToRGB(c.target);
  if(!kB || !tgt) return raw;                      /* not ready — never guess */
  if(FAB_CAL[k]) return FAB_CAL[k];
  var m = tileMean(raw, 'fabraw:'+k);
  if(!m) return raw;
  FAB_CAL[k] = recolorTile(raw, [0,1,2].map(function(i){ return tgt[i] / (kB[i] || 1); }), m);
  return FAB_CAL[k];
}
function colorByKey(k){
  for(var i=0;i<PACK_COLORS.length;i++) if(PACK_COLORS[i].k === k) return PACK_COLORS[i];
  return null;
}
/* The SWATCH CHIP in Step 3 must show the same corrected color as the mat — a chip that
   still showed the raw photograph would put a beige tile under the words "Light Gray",
   which is the complaint in miniature. */
function fabChip(k){
  if(FAB_CHIP[k]) return FAB_CHIP[k];
  var t = fabTile(k);
  if(!t || t === FAB[k]) return null;
  try { FAB_CHIP[k] = t.toDataURL('image/jpeg', 0.86); } catch(e){ return null; }
  return FAB_CHIP[k];
}

var HD_CAL = {}, HD_CAL_HEX = {};
/* The calibrated HD tile for the CURRENT package color. Keyed by chart cell AND fabric,
   because the same cell can be reached from a specialty color whose fabric differs. */
function hdTileMatched(){
  var raw = hdTile();                                   /* real chart crop, or null */
  if(!raw) return null;
  var fab = fabTile(S.color.k);            /* anchor on the CALIBRATED boarding mat */
  var kB = surfaceK('btop'), kD = surfaceK('dock');
  if(!fab || !kB || !kD) return raw;                    /* nothing to anchor to yet */
  var key = (S.hd && S.hd.c) + '@' + S.color.k;
  if(HD_CAL[key]) return HD_CAL[key];
  var fm = tileMean(fab, 'fabcal:'+S.color.k), hm = tileMean(raw, 'hd:'+(S.hd && S.hd.c));
  if(!fm || !hm) return raw;
  var target = [0,1,2].map(function(i){ return fm[i] * kB[i] / (kD[i] || 1); });
  HD_CAL[key] = recolorTile(raw, target, hm);
  var out = meanRGBA(HD_CAL[key]) || target;
  HD_CAL_HEX[key] = 'rgb(' + out.map(Math.round).join(',') + ')';
  return HD_CAL[key];
}
/* the flat fill used for the ONE frame before a tile arrives — calibrated too, so the
   pair never flashes mismatched on a color change */
function hdFallbackFill(){
  var key = (S.hd && S.hd.c) + '@' + S.color.k;
  return HD_CAL_HEX[key] || (S.hd && S.hd.h) || S.color.hd;
}

/* The Sunbrella swatches are dark, flat-lit studio shots; the mat in the scene is in
   open daylight. The ONLY thing done to one is an exposure lift — the same single
   exponent for every color, applied equally to R, G and B.
     - it does NOT move any color toward a target, which is what the old tintTile() did
       (it rescaled each channel onto a catalog hex, i.e. it replaced the photographed
       color with a guess — exactly what Patrick rejected);
     - it is reversible and auditable: one number.
   Without it the real navy (rgb 38,39,50) times the scene's own shading renders as a
   black brick, which misrepresents the product in the other direction.

   It is a GAMMA curve, not a multiply. A flat x1.45 lifts navy correctly but drives the
   tan swatch (223,197,155) into clipped white, destroying the color. Gamma leaves 0 at
   0 and 255 at 255 and opens up only the shadows, so nothing clips.
   The HD chart swatches get NO lift at all — the chart is a correctly exposed print
   reference, and lifting it turned PMS 648 navy into a royal blue. */
/* 0.65 was tuned when the package opened NAVY. With BLACK as the default (Patrick,
   2026-09-08) that lift turned SeaMark Black into an olive-khaki: the fabric really is a
   warm black — Glen Raven's own 2095-0063 swatch averages rgb(28,26,21) and BoatMat's
   plate averages rgb(27,25,20), so the warmth is the material, not a studio cast — and a
   0.65 gamma exaggerates it as it brightens. 0.85 lifts the dark colors enough to read in
   daylight while leaving black reading as black and keeping Light Gray and Tan off the
   clipping ceiling, which 0.65 combined with the old top-face multiplier did not. */
var DAYLIGHT = 0.85;
function expose(t, g){
  var c = t.getContext('2d', {willReadFrequently:true}), d;
  try { d = c.getImageData(0,0,t.width,t.height); } catch(e){ return t; }
  var px = d.data, i, k, lut = new Uint8Array(256);
  for(i=0;i<256;i++) lut[i] = Math.round(255*Math.pow(i/255, g));
  for(i=0;i<px.length;i+=4)
    for(k=0;k<3;k++) px[i+k] = lut[px[i+k]];
  c.putImageData(d,0,0);
  return t;
}

/* a 2x2 mirrored tile repeats with no visible seam */
function mirrorTile(im, sc){
  var w = Math.max(1,Math.round(im.naturalWidth*sc)), h = Math.max(1,Math.round(im.naturalHeight*sc));
  var t = document.createElement('canvas'); t.width = w*2; t.height = h*2;
  var c = t.getContext('2d');
  c.drawImage(im,0,0,w,h);
  c.save(); c.translate(w*2,0); c.scale(-1,1); c.drawImage(im,0,0,w,h); c.restore();
  c.save(); c.translate(0,h*2); c.scale(1,-1); c.drawImage(im,0,0,w,h); c.restore();
  c.save(); c.translate(w*2,h*2); c.scale(-1,-1); c.drawImage(im,0,0,w,h); c.restore();
  return t;
}

/* ------------------------------------------------------------------ *
 * 6. MATH — homography + matrix3d
 * ------------------------------------------------------------------ */
function solveH(src, dst){
  var A = [], b = [];
  for(var i=0;i<4;i++){
    var x=src[i][0], y=src[i][1], u=dst[i][0], v=dst[i][1];
    A.push([x,y,1,0,0,0,-u*x,-u*y]); b.push(u);
    A.push([0,0,0,x,y,1,-v*x,-v*y]); b.push(v);
  }
  var h = gauss(A,b);
  return [[h[0],h[1],h[2]],[h[3],h[4],h[5]],[h[6],h[7],1]];
}
function gauss(A,b){
  var n=8, M=[], i, r, c;
  for(i=0;i<n;i++) M.push(A[i].slice().concat([b[i]]));
  for(var col=0;col<n;col++){
    var p=col;
    for(r=col+1;r<n;r++) if(Math.abs(M[r][col])>Math.abs(M[p][col])) p=r;
    var t=M[col]; M[col]=M[p]; M[p]=t;
    var pv=M[col][col]||1e-9;
    for(r=0;r<n;r++){
      if(r===col) continue;
      var f=M[r][col]/pv;
      for(c=col;c<=n;c++) M[r][c]-=f*M[col][c];
    }
  }
  var out=[];
  for(i=0;i<n;i++) out.push(M[i][n]/(M[i][i]||1e-9));
  return out;
}
function invH(H){
  var a=H[0][0],b=H[0][1],c=H[0][2],d=H[1][0],e=H[1][1],f=H[1][2],g=H[2][0],h=H[2][1],i=H[2][2];
  var A=e*i-f*h, B=-(d*i-f*g), C=d*h-e*g;
  var det=a*A+b*B+c*C; if(!det) det=1e-9;
  return [[A/det,(c*h-b*i)/det,(b*f-c*e)/det],
          [B/det,(a*i-c*g)/det,(c*d-a*f)/det],
          [C/det,(b*g-a*h)/det,(a*e-b*d)/det]];
}
function applyH(H,x,y){
  var w = H[2][0]*x+H[2][1]*y+H[2][2];
  return [(H[0][0]*x+H[0][1]*y+H[0][2])/w, (H[1][0]*x+H[1][1]*y+H[1][2])/w];
}
function css3d(H){    /* CSS matrix3d is column-major */
  return 'matrix3d('+
    [H[0][0],H[1][0],0,H[2][0],
     H[0][1],H[1][1],0,H[2][1],
     0,0,1,0,
     H[0][2],H[1][2],0,H[2][2]].join(',')+')';
}

/* ------------------------------------------------------------------ *
 * 7. LOGO COLOR EXTRACTION + THREAD / INK MAPPING
 * ------------------------------------------------------------------ */
function hex2rgb(h){
  return [parseInt(h.substr(1,2),16), parseInt(h.substr(3,2),16), parseInt(h.substr(5,2),16)];
}
function rgb2hex(r,g,b){
  return '#'+[r,g,b].map(function(v){ return ('0'+Math.round(v).toString(16)).slice(-2); }).join('');
}
function dist2(a,b){ var d0=a[0]-b[0],d1=a[1]-b[1],d2=a[2]-b[2]; return d0*d0+d1*d1+d2*d2; }
/* darken a real color without changing its hue — used for the binding, which is the
   same material as the mat face, just turned away from the light */
function shade(hex,f){ var c=hex2rgb(hex); return rgb2hex(c[0]*f,c[1]*f,c[2]*f); }
/* the dominant colors actually present in the uploaded logo */
function extractPalette(img){
  var N = 72, cv = document.createElement('canvas');
  cv.width = N; cv.height = N;
  var c = cv.getContext('2d', {willReadFrequently:true});
  c.clearRect(0,0,N,N);
  var k = Math.min(N/img.naturalWidth, N/img.naturalHeight);
  var w = img.naturalWidth*k, h = img.naturalHeight*k;
  c.drawImage(img, (N-w)/2, (N-h)/2, w, h);
  var d;
  try { d = c.getImageData(0,0,N,N).data; } catch(e){ return []; }
  var bins = {};
  for(var i=0;i<d.length;i+=4){
    if(d[i+3] < 140) continue;
    var r=d[i], g=d[i+1], b=d[i+2];
    if(r>238 && g>238 && b>238) continue;              /* the paper, not the mark */
    var key = (r>>4)+','+(g>>4)+','+(b>>4);
    var e = bins[key] || (bins[key] = {n:0,r:0,g:0,b:0});
    e.n++; e.r+=r; e.g+=g; e.b+=b;
  }
  var list = Object.keys(bins).map(function(k2){
    var e = bins[k2];
    return { n:e.n, rgb:[e.r/e.n, e.g/e.n, e.b/e.n] };
  }).sort(function(a,b){ return b.n - a.n; });

  var out = [];
  for(var j=0;j<list.length && out.length<6;j++){
    var ok = true;
    for(var m=0;m<out.length;m++) if(dist2(list[j].rgb, out[m].rgb) < 1500) ok = false;
    if(ok && list[j].n > 6) out.push(list[j]);
  }
  return out.map(function(e){ return rgb2hex(e.rgb[0],e.rgb[1],e.rgb[2]); });
}
/* ---- THE BOARDING-MAT LOGO -------------------------------------------------
   CORRECTION, Patrick 2026-09-08: "The logo currently does not look like the same
   colors on the Boarding Mat and the HD DigiPrint Mat. Fix that. The uploaded source
   artwork is the authoritative visual reference."

   It used to be quantized into the eight standard LETTERING threads. On his own test
   file — the BoatMat logo, which is blue #28529A and red #EB3A52 — that mapped the red
   onto Tan, so the two mats showed two different logos. It was also the wrong model of
   the product: logo digitizing is included in every Sportfish package and the threads
   are matched to the supplied artwork when it is digitized, so the artwork's own colors
   ARE what gets sewn.

   So the logo now keeps its own colors on the Boarding Mat, exactly as on the HD mat.
   Hue, saturation and alpha are untouched; the ONLY thing added is a satin-stitch
   relief, which is a light/dark texture at matched strengths and therefore does not
   move the color. The colors found in the artwork are shown back to the customer, and the
   DESIRED THREAD COLOR field lets them ask for anything else. */
var threadCv = null, threadKey = '';
function threadedLogo(){
  if(!S.logo.ok || !S.logo.img) return null;
  var key = S.logo.name;
  if(threadCv && threadKey === key) return threadCv;

  var img = S.logo.img;
  var MAXD = 420;
  var k = Math.min(1, MAXD/Math.max(img.naturalWidth, img.naturalHeight));
  var w = Math.max(1, Math.round(img.naturalWidth*k)), h = Math.max(1, Math.round(img.naturalHeight*k));
  var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
  var c = cv.getContext('2d', {willReadFrequently:true});
  c.drawImage(img, 0, 0, w, h);
  /* embroidery has no partial coverage — a stitch is there or it is not — so only the
     ALPHA is hardened. No channel of the color is touched. */
  var d;
  try { d = c.getImageData(0,0,w,h); } catch(e){ threadCv = cv; threadKey = key; return cv; }
  var px = d.data;
  for(var i=0;i<px.length;i+=4) if(px[i+3]) px[i+3] = px[i+3] > 110 ? 255 : 0;
  c.putImageData(d, 0, 0);
  stitchTexture(c, w, h);
  threadCv = cv; threadKey = key;
  return cv;
}
/* Fine 45-degree satin-stitch relief, only where there is thread.

   THE BUG PATRICK REPORTED (2026-09-08, item 4): "The same uploaded logo currently
   appears as different colors on the Boarding Mat and HD DigiPrint™ Mat." The colors
   were no longer being quantized into thread spools — that was fixed earlier — but this
   relief pass was still LIGHTENING the embroidered copy, so the two mats disagreed.

   Why, precisely, because it is not visible by reading the old code: the tile is 6×6 and
   repeats, so a 45° line at x+y=k recurs at every k mod 6. The old tile drew white at
   x+y=4 and x+y=8 (≡ 4 and 2) and black at x+y=6 (≡ 0) — TWO highlight lines for every
   ONE shadow line, at identical alpha. The mean of the pass was therefore well above
   neutral and every embroidered logo came out lighter than the same artwork printed.

   Now it is one highlight and one shadow, equal alpha, evenly spaced 3px apart
   (x+y ≡ 3 and x+y ≡ 0), so the pass adds relief without moving the mean. The stitch
   still reads; the color does not travel. Do not add a third line to either pass. */
function stitchTexture(c, w, h){
  c.save();
  c.globalCompositeOperation = 'source-atop';
  var t = document.createElement('canvas'); t.width = 6; t.height = 6;
  var tc = t.getContext('2d');
  tc.lineWidth = 1.4;
  tc.strokeStyle = 'rgba(255,255,255,.26)';                      /* x+y = 3 */
  tc.beginPath(); tc.moveTo(-1,4); tc.lineTo(4,-1); tc.stroke();
  tc.strokeStyle = 'rgba(0,0,0,.26)';                            /* x+y = 6 -> 0 mod 6 */
  tc.beginPath(); tc.moveTo(-1,7); tc.lineTo(7,-1); tc.stroke();
  c.globalAlpha = .34;
  c.fillStyle = c.createPattern(t,'repeat');
  c.fillRect(0,0,w,h);
  c.restore();
}
/* The HD mat prints the logo AS SUPPLIED, in its own colors — the same artwork, treated
   the same way, as the embroidered Boarding Mat. The "print my logo in one chart color"
   option went with the ink-color box on 2026-09-08: a matching package does not give the
   customer a second, separate treatment for the printed mat. */
var inkKey = '';
function inkedLogo(){
  if(!S.logo.ok || !S.logo.img) return null;
  return S.logo.img;
}
function logoFor(which){ return which==='board' ? threadedLogo() : inkedLogo(); }

/* ------------------------------------------------------------------ *
 * 8. ARTWORK MEASUREMENT + THE 75% RULE
 * ------------------------------------------------------------------ */
var mCv = document.createElement('canvas'), mCtx = mCv.getContext('2d');

function fontStr(f, px){ return (f.it?'italic ':'')+(f.w||'700')+' '+px+'px '+f.css; }
function shownText(){
  var t = (S.vessel||'').trim();
  return S.font.up ? t.toUpperCase() : t;
}
/* Logo + name on a long thin surface has to sit SIDE BY SIDE. The boarding mat's
   embroidery zone is 26.8" x 8.2" — stacking the mark above the name there shrinks the
   whole group to about half size to make it fit, which is not how a digitiser would set
   it. Each product picks its own layout from its own safe area. */
function comboLayout(which){
  var sf = safeOf(which);
  return (sf.w / sf.h) > 2.2 ? 'row' : 'stack';
}
var TXT_REL = 0.72, COMBO_GAP = 0.08;      /* name height and gap, relative to the group */

function textAspect(){
  mCtx.font = fontStr(S.font,100);
  return 100/(mCtx.measureText(shownText()).width || 100);
}
function artAspect(which){
  var lg = logoFor(which);
  var hasLogo = (S.mode!=='text') && S.logo.ok && lg;
  var hasText = (S.mode!=='logo') && shownText().length>0;
  if(!hasLogo && !hasText) return null;
  var lw = lg ? (lg.naturalWidth||lg.width) : 1, lh = lg ? (lg.naturalHeight||lg.height) : 1;
  if(hasLogo && !hasText) return lh/lw;
  if(hasText && !hasLogo) return textAspect();
  var la = lh/lw, ta = textAspect();
  if(comboLayout(which) === 'row')          /* group height / group width */
    return 1/(1/la + COMBO_GAP + TXT_REL/ta);
  return la + 0.09 + 0.34*ta;               /* mark above, name beneath */
}
/* {w,h} in inches after the safe-area fit, or null */
function artBox(which){
  var a = S.art[which], sf = safeOf(which), asp = artAspect(which);
  if(asp === null) return null;
  var w = sf.w * a.sN, h = w*asp;
  var rad = a.rot*Math.PI/180, ca = Math.abs(Math.cos(rad)), sa = Math.abs(Math.sin(rad));
  var rw = w*ca + h*sa, rh = w*sa + h*ca;
  if(rw > sf.w || rh > sf.h){                       /* never leaves the safe area */
    var k = Math.min(sf.w/rw, sf.h/rh);
    w *= k; h *= k; rw *= k; rh *= k;
  }
  return { w:w, h:h, rw:rw, rh:rh, asp:asp };
}
/* center of the artwork, in inches, within the product's own design surface */
function artCenter(which, box){
  var sf = safeOf(which), a = S.art[which];
  var ix = which==='board' ? B_INSET_X : D_INSET;
  var iy = which==='board' ? B_INSET_Y : D_INSET;
  var freeX = Math.max(0, sf.w - box.rw), freeY = Math.max(0, sf.h - box.rh);
  return { x: ix + box.rw/2 + a.xN*freeX, y: iy + box.rh/2 + a.yN*freeY };
}

/* ------------------------------------------------------------------ *
 * 9. DRAWING ARTWORK into design space (units: inches * ppi)
 * ------------------------------------------------------------------ */
function drawArt(ctx, which, ppi){
  var box = artBox(which); if(!box) return;
  var pos = artCenter(which, box);
  var a = S.art[which], lg = logoFor(which);
  var hasLogo = (S.mode!=='text') && S.logo.ok && lg;
  var hasText = (S.mode!=='logo') && shownText().length>0;
  var hex = which==='board' ? S.thread.hex : S.ink.h;

  ctx.save();
  ctx.translate(pos.x*ppi, pos.y*ppi);
  ctx.rotate(a.rot*Math.PI/180);
  var W = box.w*ppi, H = box.h*ppi;

  if(hasLogo && !hasText){
    softShadow(ctx, function(){ ctx.drawImage(lg, -W/2, -H/2, W, H); });
  } else if(hasText && !hasLogo){
    paintText(ctx, shownText(), 0, 0, W, hex);
  } else if(hasLogo && hasText){
    var la = (lg.naturalHeight||lg.height) / (lg.naturalWidth||lg.width);
    if(comboLayout(which) === 'row'){
      var wl = H/la, gp = H*COMBO_GAP, wt = W - wl - gp;
      softShadow(ctx, function(){ ctx.drawImage(lg, -W/2, -H/2, wl, H); });
      paintText(ctx, shownText(), -W/2 + wl + gp + wt/2, 0, wt, hex, H*TXT_REL);
    } else {
      var lh2 = W*la, gap = W*0.09, th = H - lh2 - gap;
      softShadow(ctx, function(){ ctx.drawImage(lg, -W/2, -H/2, W, lh2); });
      paintText(ctx, shownText(), 0, -H/2 + lh2 + gap + th/2, W, hex, th);
    }
  }
  ctx.restore();
}
function softShadow(ctx, fn){
  ctx.save(); ctx.globalAlpha=.30; ctx.translate(2.2,2.6);
  ctx.filter='blur(1px)'; fn(); ctx.restore();
  ctx.save(); fn(); ctx.restore();
}
function paintText(ctx, txt, cx, cy, targetW, hex, targetH){
  if(!txt) return;
  ctx.save();
  ctx.textAlign='center'; ctx.textBaseline='middle';
  ctx.font = fontStr(S.font, 100);
  var px = 100 * (targetW / (ctx.measureText(txt).width || 1));
  if(targetH) px = Math.min(px, targetH*1.28);
  ctx.font = fontStr(S.font, px);
  ctx.save(); ctx.globalAlpha=.42; ctx.fillStyle='#000';
  ctx.fillText(txt, cx+px*0.018, cy+px*0.022); ctx.restore();
  ctx.fillStyle = hex; ctx.fillText(txt, cx, cy);
  ctx.save(); ctx.globalAlpha=.26; ctx.fillStyle='#fff';
  ctx.fillText(txt, cx-px*0.008, cy-px*0.010); ctx.restore();
  ctx.fillStyle = hex; ctx.globalAlpha=.55; ctx.fillText(txt, cx, cy); ctx.globalAlpha=1;
  ctx.restore();
}

/* ------------------------------------------------------------------ *
 * 10. PHOTOREAL SURFACE PAINTING
 *     result = base(fabric | HD color) x r , r = normalized luminance of
 *     the approved photograph. The highlight adds base x (r-1), NOT white,
 *     so the material keeps its own hue.
 * ------------------------------------------------------------------ */
var tmpCv = document.createElement('canvas'), tmpCtx = tmpCv.getContext('2d');
var mskCv = document.createElement('canvas'), mskCtx = mskCv.getContext('2d');
var artCv = document.createElement('canvas'), artCtx = artCv.getContext('2d');
var artRaw = document.createElement('canvas'), artRawCtx = artRaw.getContext('2d');

/* HOW MUCH OF THE SURFACE'S OWN LIGHTING IS ALLOWED ONTO THE CUSTOMER'S ARTWORK.
   Patrick, 2026-09-08: "Do not alter hue, saturation, transparency, color balance
   because of masks, filters, blending modes or background-color processing."

   Artwork is therefore composited on its own layer AFTER the mat's photoreal shading,
   never underneath it, and the only thing applied is a softened multiply by the mat's
   own luminance — the same single constant for BOTH products, so a logo cannot come out
   of the boarding mat looking different from the same logo on the HD mat. On the flat
   Design View proofs the strength is 0 for both, because a production proof shows the
   artwork as supplied. Hue and saturation are never touched at any strength. */
var ART_SHADE = 0.35;

/* 3-slice horizontal draw: the bound ends keep their real width when the mat
   gets wider, instead of the binding stretching with the mat. */
function drawMapX(c, im, W, H, endPx){
  var e = Math.min(endPx, im.naturalWidth/2 - 1);
  var eo = e * (W / im.naturalWidth);
  if(W <= e*2 + 4){ c.drawImage(im, 0, 0, W, H); return; }
  c.drawImage(im, 0, 0, e, im.naturalHeight, 0, 0, eo, H);
  c.drawImage(im, e, 0, im.naturalWidth-2*e, im.naturalHeight, eo, 0, W-2*eo, H);
  c.drawImage(im, im.naturalWidth-e, 0, e, im.naturalHeight, W-eo, 0, eo, H);
}
function paintSurface(cv, mapName, wPx, hPx, paintBase, paintOver, endPx, paintArt, artShade){
  cv.width  = Math.max(2, Math.round(wPx));
  cv.height = Math.max(2, Math.round(hPx));
  var c = cv.getContext('2d'), W = cv.width, H = cv.height;
  c.setTransform(1,0,0,1,0,0);
  c.globalCompositeOperation='source-over'; c.globalAlpha=1;
  c.clearRect(0,0,W,H);

  paintBase(c, W, H);
  if(paintOver) paintOver(c, W, H);

  var M = MAPS[mapName];
  if(!M || !M.mul || !M.add){ if(paintArt) paintArt(c, W, H); return; }
  endPx = endPx || 0;

  /* The silhouette has to be laid down as ONE image: destination-in is a Porter-Duff
     operator, so drawing the map in three slices would make each slice erase what the
     other two need.  Flatten it on a scratch canvas first. */
  mskCv.width=W; mskCv.height=H;
  mskCtx.setTransform(1,0,0,1,0,0);
  mskCtx.globalCompositeOperation='source-over'; mskCtx.clearRect(0,0,W,H);
  drawMapX(mskCtx, M.mul, W, H, endPx);

  tmpCv.width=W; tmpCv.height=H;
  tmpCtx.setTransform(1,0,0,1,0,0);
  tmpCtx.globalCompositeOperation='source-over'; tmpCtx.clearRect(0,0,W,H);
  tmpCtx.drawImage(cv,0,0);
  tmpCtx.globalCompositeOperation='multiply';
  drawMapX(tmpCtx, M.add, W, H, endPx);                  /* content x (r-1) */

  c.globalCompositeOperation='multiply';
  c.drawImage(mskCv,0,0);                                /* content x min(r,1) */
  c.globalCompositeOperation='lighter';
  c.drawImage(tmpCv,0,0);                                /* highlights, tinted */
  c.globalCompositeOperation='destination-in';
  c.drawImage(mskCv,0,0);                                /* true silhouette */
  c.globalCompositeOperation='source-over';

  /* ---- THE CUSTOMER'S ARTWORK, on its own layer, ON TOP of the shading ----
     It used to be painted into the base and then run through the same multiply/add
     pass as the material, which is exactly the "background-color processing" Patrick
     ruled out: the mat's own lighting was being baked into the logo, differently on
     each product because the two mats carry different luminance maps. */
  if(!paintArt) return;
  artCv.width=W; artCv.height=H;
  artCtx.setTransform(1,0,0,1,0,0);
  artCtx.globalCompositeOperation='source-over'; artCtx.globalAlpha=1;
  artCtx.clearRect(0,0,W,H);
  paintArt(artCtx, W, H);

  var sh = (artShade === undefined) ? ART_SHADE : artShade;
  if(sh > 0){
    /* keep the artwork's own alpha so the softened multiply can be clipped back to it —
       'multiply' would otherwise paint the map's silhouette into the empty areas */
    artRaw.width=W; artRaw.height=H;
    artRawCtx.setTransform(1,0,0,1,0,0);
    artRawCtx.globalCompositeOperation='source-over'; artRawCtx.globalAlpha=1;
    artRawCtx.clearRect(0,0,W,H);
    artRawCtx.drawImage(artCv,0,0);

    artCtx.globalAlpha = sh;                             /* dst x (1-sh + sh x map) */
    artCtx.globalCompositeOperation='multiply';
    drawMapX(artCtx, M.mul, W, H, endPx);
    artCtx.globalAlpha = 1;
    artCtx.globalCompositeOperation='destination-in';    /* alpha only — no color move */
    artCtx.drawImage(artRaw,0,0);
    artCtx.globalCompositeOperation='source-over';
  }

  c.drawImage(artCv,0,0);
  c.globalCompositeOperation='destination-in';
  c.drawImage(mskCv,0,0);                                /* artwork cannot leave the mat */
  c.globalCompositeOperation='source-over';
}
/* How much REAL material each swatch image covers. A pattern has to be laid down at the
   size the material actually is: tiled at its own pixel size, one chart swatch stretched
   across ~9″ of mat, so the carpet's loop pattern repeated six times over and read as
   wallpaper instead of texture. Tiling at true scale puts the grain where the eye
   expects it and the repeat becomes invisible. */
var SWATCH_IN = 2.2;      /* one HD chart cell ≈ 2.2″ of printed carpet */
var FABRIC_IN = 3.0;      /* one Sunbrella swatch photo ≈ 3″ of cloth   */

function tiled(c, t, W, H, tilePx, fallback){
  if(!t){ c.fillStyle = fallback; c.fillRect(0,0,W,H); return; }
  var p = c.createPattern(t,'repeat'), s = tilePx / t.width;
  if(p && p.setTransform){
    p.setTransform(new DOMMatrix([s,0,0,s,0,0]));
    c.fillStyle = p;
  } else {                                   /* older canvas: rasterize at target size */
    var sc = document.createElement('canvas');
    sc.width = Math.max(2,Math.round(t.width*s)); sc.height = Math.max(2,Math.round(t.height*s));
    sc.getContext('2d').drawImage(t,0,0,sc.width,sc.height);
    c.fillStyle = c.createPattern(sc,'repeat');
  }
  c.fillRect(0,0,W,H);
}
function fabricBase(c,W,H,ppi){
  /* fabTile(), not FAB[] — the mat is painted in the PRODUCT color, on the photographed
     weave. The fallback is the product color too, so the one pre-load frame is right. */
  tiled(c, fabTile(S.color.k), W, H, FABRIC_IN*(ppi||B_PPI), S.color.target || S.color.fab);
}
function hdBase(c,W,H,ppi){
  /* hdTileMatched(), not hdTile(): the printed color is anchored to the Boarding Mat so
     the package reads as the matching set it is sold as. See 5b — production data is
     untouched. */
  tiled(c, hdTileMatched(), W, H, SWATCH_IN*(ppi||D_PPI), hdFallbackFill());
}
/* soft shadow plate, drawn in its own design space then projected */
function paintShadow(cv, w, h, blur, alpha){
  cv.width = Math.max(4, Math.round(w)); cv.height = Math.max(4, Math.round(h));
  var c = cv.getContext('2d'), W = cv.width, H = cv.height;
  c.clearRect(0,0,W,H);
  var pad = Math.min(W,H)*0.14;
  c.filter = 'blur('+blur+'px)';
  c.fillStyle = 'rgba(0,0,0,'+alpha+')';
  c.fillRect(pad, pad, W-pad*2, H-pad*2);
  c.filter = 'none';
}

/* ------------------------------------------------------------------ *
 * 11. SPORTFISH PACKAGE VIEW
 * ------------------------------------------------------------------ */
var B_PPI = 40, D_PPI = 20;

function renderPackage(){
  if(!READY || !CAM) return;
  DRAWING_SCENE = true;
  var w = S.boardW;

  paintShadow(el('sfDockSh'), 300, 190, 16, .40);
  place('sfDockSh', dockShadowQuad());

  paintSurface(el('sfDock'), 'dock', DOCK_MAT[0]*D_PPI, DOCK_MAT[1]*D_PPI, hdBase, null, 34,
    function(c){ drawArt(c, 'dock', D_PPI); }, ART_SHADE);
  place('sfDock', dockQuad());

  paintShadow(el('sfDrapeSh'), 240, 150, 11, .34);
  place('sfDrapeSh', drapeShadowQuad(w));

  paintSurface(el('sfDrape'), 'bdrape', w*B_PPI, DRAPE_DEEP*B_PPI, fabricBase, null, 46);
  place('sfDrape', boardDrapeQuad(w));

  paintShadow(el('sfTopSh'), 240, 130, 9, .26);
  place('sfTopSh', topShadowQuad(w));

  /* the SAME ART_SHADE as the HD mat above — that is what makes one logo read as one
     logo across the two products */
  paintSurface(el('sfTop'), 'btop', w*B_PPI, TOP_DEEP*B_PPI, fabricBase, null, 46,
    function(c){ drawArt(c, 'board', B_PPI); }, ART_SHADE);
  place('sfTop', boardTopQuad(w));
  DRAWING_SCENE = false;
}
function place(id, quad){
  var cv = el(id); if(!cv) return;
  var H = solveH([[0,0],[cv.width,0],[cv.width,cv.height],[0,cv.height]], quad);
  cv.style.width = cv.width+'px'; cv.style.height = cv.height+'px';
  cv.style.transform = css3d(H);
  cv._H = H;
}
/* ------------------------------------------------------------------ *
 * THE STEP 3 HEADING FITS ON ONE LINE — ON EVERY DEVICE
 *
 * Patrick asked twice for that heading to stop stacking, and the CSS sizes it by
 * dividing the container width by the line's measured width-to-font-size ratio. That
 * ratio is NOT constant across devices: the same deployed page, same viewport, same
 * font-size, measured 291.6px wide under a desktop user agent and 337.6px — 16% wider —
 * under an iPhone 13 user agent, because Google Fonts serves a different Bebas Neue file
 * to iOS. A CSS-only fit therefore cannot be right everywhere at once: tuned for the
 * desktop it clips on a real iPhone, and tuned for the iPhone it is needlessly small on
 * everything else.
 *
 * So the CSS carries the IDEAL size and this trims it to the truth: with white-space
 * nowrap, scrollWidth is the line's real width and clientWidth is the room it has, so
 * shrinking while the first exceeds the second converges on the largest size that
 * actually fits, whatever face the device ended up with. It runs after the webfont
 * lands and on resize, and it clears its own inline size first so the CSS breakpoints
 * still decide the starting point.
 * ------------------------------------------------------------------ */
function fitHeading(){
  var h = document.querySelector('#step3 .steph h2');
  if(!h) return;
  h.style.fontSize = '';                       /* back to whatever the CSS says */
  if(!h.clientWidth) return;
  var size = parseFloat(getComputedStyle(h).fontSize);
  for(var i = 0; i < 40 && h.scrollWidth > h.clientWidth && size > 9.5; i++){
    size *= 0.98;
    h.style.fontSize = size.toFixed(2) + 'px';
  }
}

/* The plate's top strip is empty water and its bottom strip empty teak — neither shows
   any product, so both are cropped away. The stage's aspect-ratio in the CSS must stay
   1600 / SCENE_VIS_H, and every scene->page coordinate has to add SCENE_CROP_TOP back. */
var SCENE_CROP_TOP = 0, SCENE_VIS_H = 1150;   /* overwritten from scene-cam.json */
function fitScene(){
  var st = el('stage'); if(!st) return;
  st.style.aspectRatio = IMG_W + ' / ' + SCENE_VIS_H;
  var k = st.clientWidth / IMG_W;
  el('scene').style.transform = 'scale('+k+') translateY(-'+SCENE_CROP_TOP+'px)';
  st._k = k;
}

/* ------------------------------------------------------------------ *
 * 12. (REMOVED) DESIGN VIEW — the flat per-mat proof editors
 *     Patrick, 2026-09-08: "Do not show the blue square/layout editor. Do not make
 *     the customer design the same thing twice." The whole section — renderDesign(),
 *     drawBoardProof(), drawDockProof(), proofScale(), dimLine(), the dimension and
 *     SANDBAG annotation, PROOF_MAXH and the DIMBUCKET introspection — is DELETED
 *     along with the cvBoard / cvDock canvases it painted. The customer sees the
 *     artwork on the mats in the finished-package preview and nowhere else.
 *     Do not reintroduce a flat proof editor on this page.
 *
 *     DRAWING_SCENE stays: renderPackage() still sets it, and the QA suites still
 *     assert that no construction line or SANDBAG label was ever painted onto the
 *     lifestyle scene. With the proof renderer gone nothing can set these true, which
 *     is the point — the assertion now proves the whole class of bug is impossible.
 * ------------------------------------------------------------------ */
var DRAWING_SCENE = false;
window.__dimOnScene = false; window.__sandbagOnScene = false;

/* ------------------------------------------------------------------ *
 * 13. RENDER ORCHESTRATION
 * ------------------------------------------------------------------ */
function el(id){ return document.getElementById(id); }
/* ONE preview — the finished package scene, below the four steps. The flat per-mat
   proofs were deleted 2026-09-08; there is nothing else on the page to repaint. */
function renderAll(){
  syncChrome();
  renderPackage();
}
/* The scene's surfaces repaint together, so a drag is coalesced onto the frame instead
   of repainting per pointer event. */
var rafPending = false;
function renderSoon(){
  if(rafPending) return;
  rafPending = true;
  requestAnimationFrame(function(){ rafPending = false; renderAll(); });
}
function pkgOf(k){ for(var i=0;i<PACKAGES.length;i++) if(PACKAGES[i].key===k) return PACKAGES[i]; }

/* the Boarding Mat color as the customer named it — a specialty color keeps the name
   they typed, because that string is what production has to source */
function colorLabel(){
  if(!S.specialty) return S.color.n + ' Sunbrella®';
  var t = (S.specialtyName||'').trim();
  return 'Specialty Sunbrella® — ' + (t ? t : 'color to be confirmed') + ' (+$35.00)';
}

/* =====================================================================
   CUSTOMER-FACING COLOR NAMES — Patrick, 2026-09-08, items 11–13.
   "Do NOT display PMS numbers/codes to the customer in the Design Station.
    The customer should see the ACTUAL COLOR NAME… Do NOT invent a color name
    based solely on what a PMS number looks like."

   THE CONSTRAINT THAT DECIDES THIS, and it is worth stating once so nobody
   "improves" it later: BoatMat's HD DigiPrint chart has NO customer-facing
   color names. The only name printed under each of the 150 swatches is the
   PMS number itself (hd-colors.js, straight off Patrick's own chart). So
   there is no BoatMat name data for a chart cell to look up, and inventing
   one — "PMS 648 is a navy, call it Navy" — is exactly what he ruled out.

   What makes this work is that neither HD color is chosen independently any
   more: this is a matching package. The HD mat's background IS the Boarding
   Mat color, and the HD print IS the embroidery thread color. Both of those
   DO have real BoatMat names — the six stocked Sunbrella colorways and the
   eight stocked thread colors — so the customer-facing name of each HD color
   is simply the name of the thing it was matched to. Nothing is invented and
   nothing is guessed.

   The chart cell and PMS number are NOT deleted: coordinate() still resolves
   both, they still travel to production via prodSpec(), and the Shopify
   line-item properties still carry them. They are just never shown to a
   customer.
   ===================================================================== */
/* the HD DigiPrint mat's background, in words a customer reads */
/* Always a bare NAME, so it reads correctly whether it is dropped into a sentence or
   into the configuration list. A specialty Boarding Mat is sourced to order, so the HD
   mat is matched to whatever the customer named — and if they have not named it yet we
   say so rather than printing a color we have not seen. */
function hdBgName(){
  if(!S.specialty) return S.color.n;
  var t = (S.specialtyName||'').trim();
  return t ? t : 'your specialty Sunbrella® color';
}
/* what the artwork is printed in, in words a customer reads */
function hdInkName(){ return S.thread.n; }
/* The technical side of the same two colors — chart cell + PMS. Production reads this;
   the customer never sees it. Keep these two functions the ONLY place the codes are
   formatted, so a code can never leak into customer copy by accident. */
function prodSpec(){
  return {
    hdCell:  S.hd  ? S.hd.c  : '',  hdPms:  S.hd  ? S.hd.n  : '',
    inkCell: S.ink ? S.ink.c : '',  inkPms: S.ink ? S.ink.n : ''
  };
}
function packageTotal(){
  return pkgOf(S.pkg).priceNum + (S.specialty ? SPECIALTY_UPCHARGE : 0);
}
function money(v){ return '$' + v.toFixed(2); }

function syncChrome(){
  var p = pkgOf(S.pkg);
  el('capPkg').textContent = p.name.toUpperCase() + ' Package';
  el('capSpec').textContent = S.boardW+'″ Boarding Mat  +  '+DOCK_LABEL+' '+DOCK_NAME;
  el('capPrice').textContent = money(packageTotal());
  /* dvBoardDim / dvDockDim, the artwork size readouts and the panel/tab highlighting all
     went with the per-mat editors (Patrick, 2026-09-08). There is one preview and no
     product tabs, so there is nothing here to keep in sync but the caption. */

  /* THE COLORS CAPTION IS GONE (Patrick, 2026-09-08, final pass): "Remove these two
     lines completely… Do not replace either line with anything. Keep that area clean."
     There is no #pairNote element to write to any more — do not add one back.
     Nothing about the ORDER changed: cartSummary() still carries Boarding Mat Color,
     Embroidery Thread Color, HD Mat Background Color and HD Print / Ink Color, and
     prodSpec() still carries the chart cells and PMS numbers to production. */

  syncReview();
}

/* ---- the order the customer is actually building ----
   THE CONFIGURATION SUMMARY, in the shape Patrick specified (item 13):

     Package                  Large Sportfish — 40″ Boarding Mat + 3′ × 5′ HD DigiPrint™ Mat
     Boarding Mat Color       Navy Sunbrella®
     Embroidery Thread Color  Gold
     HD Mat Background Color  Navy — matched to the Boarding Mat, binding to match
     HD Print / Ink Color     Gold — matched to your Gold embroidery thread
     Included                 Logo Digitizing · Artwork Setup

   Labels are Title Case and match his wording exactly. Values are ACTUAL COLOR NAMES —
   no chart cell, no PMS number anywhere in this list (item 11). The technical codes ride
   along in prodSpec() for production and never appear here. */
function cartSummary(){
  var p = pkgOf(S.pkg), rows = [];
  rows.push(['Package', p.name + ' — ' + S.boardW + '″ Boarding Mat + ' + DOCK_LABEL + ' HD DigiPrint™ Mat']);
  rows.push(['Boarding Mat Color', colorLabel()]);
  rows.push(['Embroidery Thread Color', S.thread.n +
    (needsThread() ? '' : ' (no lettering on this design)')]);
  if((S.threadRequest||'').trim())
    rows.push(['Desired Thread Color', '“' + S.threadRequest.trim() + '” — requested, we will match it']);
  /* Both HD colors are DERIVED from the one Boarding Mat decision — matching package —
     so each one's customer-facing name is the name of what it was matched to. */
  rows.push(['HD Mat Background Color',
    hdBgName() + ' — matched to the Boarding Mat, binding to match']);
  rows.push(['HD Print / Ink Color',
    hdInkName() + ' — matched to your ' + S.thread.n + ' embroidery thread']);
  var nm = shownText();
  if(S.mode!=='logo' && nm) rows.push(['Vessel Name', '“' + nm + '” in ' + S.font.n]);
  if(S.mode!=='text' && S.logo.ok){
    rows.push(['Logo', S.logo.name]);
    rows.push(['Logo Colors', 'as supplied, on both mats — embroidery threads matched to your ' +
      'artwork when it is digitized' +
      (S.logo.palette.length ? ' (' + S.logo.palette.join(' · ') + ')' : '')]);
  }
  /* A gallery number is a LOOK the customer likes. It is never an instruction to reuse
     another vessel's artwork, and the row says so in the order itself. */
  var refs = [];
  if(S.refBoard) refs.push(refLabel('board', S.refBoard));
  if(S.refHd)    refs.push(refLabel('hd', S.refHd));
  if(refs.length)
    rows.push(['Gallery Example You Like', refs.join(' · ') +
      ' — style, color and layout reference only, artwork is not copied']);
  if((S.notes||'').trim()) rows.push(['Special Notes or Instructions', S.notes.trim()]);
  rows.push(['Included', 'Logo Digitizing · Artwork Setup']);
  return { pkg:p, rows:rows };
}
/* Everything in the summary can contain text the customer typed — a vessel name, a
   specialty color, a requested thread color, a page of special notes — so it is
   escaped before it goes anywhere near innerHTML. */
function esc(s){
  return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
                  .replace(/"/g,'&quot;');
}
function syncReview(){
  var s = cartSummary();
  el('revList').innerHTML = s.rows.map(function(r){
    return '<li><span>'+esc(r[0])+'</span><b>'+esc(r[1]).replace(/\n/g,'<br>')+'</b></li>';
  }).join('');
  el('revTotal').innerHTML = 'PACKAGE TOTAL <em>' + money(packageTotal()) + '</em>' +
    (S.specialty ? ' <span style="font-size:.62rem;letter-spacing:.12em;color:var(--silver)">'+
      '(includes $35.00 specialty Sunbrella® color)</span>' : '');
  el('addCart').textContent = 'Add to Cart — ' + money(packageTotal());
}
/* PROTOTYPE: no checkout is wired up, and none may be (review-before-live). The button
   shows exactly what would be sent to Shopify, including the SKU the price is taken
   from server-side, so the flow can be reviewed without anything going live. */
/* THE CART DISPLAY RULE (Patrick, item 12): what the customer reads in the cart is the
   ACTUAL COLOR NAME, never a PMS number or an internal chart code — the same rule as the
   Design Station itself. The technical codes are not lost: they go down as separate
   production-only properties, shown here under their own heading so the split is visible
   in the proof. Nothing else about the cart is touched — the integration is not built. */
function addToCart(){
  var s = cartSummary(), m = el('cartMsg'), ps = prodSpec();
  m.hidden = false;
  m.innerHTML = '<b>PROTOTYPE — CHECKOUT IS NOT CONNECTED.</b> This is what would go into the cart:'+
    '<br>' + s.pkg.sku + ' — ' + s.pkg.name + ' Package — ' + money(packageTotal()) +
    '<br>' + s.rows.map(function(r){
      return esc(r[0]) + ': ' + esc(r[1]).replace(/\n/g,' / ');
    }).join('<br>') +
    '<br><br><b>PRODUCTION DATA — NOT SHOWN TO THE CUSTOMER.</b>' +
    '<br>_hd_chart_cell: ' + esc(ps.hdCell) + ' (' + esc(ps.hdPms) + ')' +
    '<br>_ink_chart_cell: ' + esc(ps.inkCell) + ' (' + esc(ps.inkPms) + ')';
  m.scrollIntoView({behavior:'smooth', block:'center'});
}

/* ------------------------------------------------------------------ *
 * 14. UI BUILD
 * ------------------------------------------------------------------ */
/* The EMBROIDERY THREAD COLOR is the color the LETTERING is sewn in. An uploaded logo
   is sewn in threads matched to the artwork itself when it is digitized, so it is not
   pushed through this control — see threadedLogo(). */
function needsThread(){ return S.mode !== 'logo'; }
/* contentSummary() and gotoDesign() went with the per-mat LOGO / TEXT blocks (Patrick,
   2026-09-08). What is on the mats is answered by the finished-package preview and by the
   Step 4 review list, not by a summary line repeated inside two editors. */

function buildUI(){
  /* ---- STEP 1: the two package cards ARE the selector ---- */
  /* Patrick, 2026-09-08 (evening) — the card says, in this order and in these words:
        <package name>
        RECOMMENDED FOR BOATS 30′–50′   /   50′ AND ABOVE
        <price>
        THIS PACKAGE INCLUDES:
          • 30″ (or 40″) Custom Embroidered Boarding Mat
          • Matching 5′ × 3′ HD DigiPrint™ Dock Mat
     BOTH packages carry the matching Dock Mat — only the Boarding Mat width changes —
     and every word of it is white. The old green "Logo Digitizing Included" / "Artwork
     Included" bullets came out of the list because his includes list is those two lines;
     the fact itself is stated under the cards in .pricenote and is not lost. */
  el('priceCards').innerHTML = PACKAGES.map(function(p){
    return '<button class="pcard'+(S.pkg===p.key?' on':'')+'" onclick="setPkg(\''+p.key+'\')">'+
      /* NO BADGE. The MOST POPULAR pill was deleted 2026-09-08 — both packages are equal
         and the recommended-boats line is the only thing that separates them. */
      '<span class="nm">'+p.name.toUpperCase()+' PACKAGE</span>'+
      '<span class="ves">'+p.vessels.toUpperCase()+'</span>'+
      '<span class="pr">'+p.price+'</span>'+
      '<span class="inclh">This Package Includes:</span>'+
      '<ul><li>'+p.board+'″ Custom Embroidered Boarding Mat</li>'+
      '<li>'+CARD_DOCK_LINE+'</li></ul></button>';
  }).join('');

  /* ---- STEP 2: the six stocked Sunbrella colors, then the specialty option ----
     One choice. The HD DigiPrint mat and its binding follow it, so the package always
     reads as a coordinated pair. Each swatch is the real photographed fabric. */
  /* NAME ONLY under each swatch. This line used to read "HD N1 · PMS 648" and the hover
     title carried the chart cell too — both removed under item 11. The cell still drives
     what the HD mat is painted with (c.hdCell -> coordinate() -> hdTile()); it is simply
     not customer-facing any more. */
  el('fabList').innerHTML = PACK_COLORS.map(function(c,i){
    /* the chip shows the SAME corrected color as the mat it selects */
    var chip = fabChip(c.k) || c.img;
    return '<button class="fab'+((!S.specialty && S.color.k===c.k)?' on':'')+'" onclick="setColor('+i+')" '+
      'title="'+c.n+' Sunbrella® — your HD DigiPrint™ Mat is made to match">'+
      '<span class="one" style="background:'+(c.target||c.fab)+';background-image:url('+chip+')"></span>'+
      '<span class="n">'+c.n+'</span>'+
      '<span class="pms">Sunbrella®</span></button>';
  }).join('') +
    '<button class="fab spec'+(S.specialty?' on':'')+'" onclick="setSpecialty()" '+
    'title="Any other Sunbrella color, sourced to order">'+
      '<span class="one">+$35</span>'+
      '<span class="n">Specialty Sunbrella®</span>'+
      '<span class="pms">non-stock color</span></button>';
  el('specBox').hidden = !S.specialty;
  el('specPreviewName').textContent = S.color.n;
  if(el('specName').value !== S.specialtyName) el('specName').value = S.specialtyName;

  /* ---- STEP 3: one logo, one vessel name, one lettering style ---- */
  el('fontSeg').innerHTML = FONTS.map(function(f,i){
    return '<button class="'+(S.font.k===f.k?'on':'')+'" onclick="setFont('+i+')" '+
      'style="font-family:'+f.css.replace(/"/g,'&quot;')+'">'+f.n+'</button>';
  }).join('');
  el('mLogo').className = S.mode==='logo'?'on':'';
  el('mText').className = S.mode==='text'?'on':'';
  el('mBoth').className = S.mode==='both'?'on':'';
  el('fldLogo').hidden = (S.mode==='text');
  el('fldText').hidden = (S.mode==='logo');
  el('fldFont').hidden = (S.mode==='logo');
  if(S.logo.ok){ el('upStat').classList.add('on'); el('upTxt').textContent = S.logo.name+' — ready'; }
  if(el('vessel').value !== S.vessel) el('vessel').value = S.vessel;

  /* ---- BOARDING MAT PANEL — thread, then the request field ----
     The thread selector is always on screen, in Patrick's order (color, then thread,
     then the artwork controls). It sets the LETTERING color; an uploaded logo keeps
     its own colors, so it is never pushed through this control. */
  /* Each thread is a NAMED tile, not a bare 30px dot: a color chip plus the color's
     actual name, in a grid that fills the step's width (Patrick, items 7 and 11). The
     name was previously only in a `title`, which a phone can never show. */
  var hasLogo = S.logo.ok && S.mode!=='text';
  el('threadList').innerHTML = THREADS.map(function(t,i){
    return '<button class="'+(S.thread.n===t.n?'on':'')+'" title="'+t.n+' embroidery thread" '+
      'aria-pressed="'+(S.thread.n===t.n?'true':'false')+'" onclick="setThread('+i+')">'+
      '<span class="dot" style="background:'+t.hex+'"></span>'+
      '<span class="tn">'+t.n+'</span></button>';
  }).join('');
  el('threadLab').textContent = needsThread()
    ? 'The color your lettering is embroidered in.'
    : 'The color any lettering is embroidered in. Add a vessel name in Step 2 to use it.';
  var tnote = needsThread()
    ? 'Your lettering is sewn in <b style="color:'+S.thread.hex+'">■</b> ' + S.thread.n + ' thread.'
    : '';
  if(hasLogo){
    /* Deliberately does NOT list "closest standard colors" any more. Naming the nearest
       spool to every color in an uploaded logo is what made a red logo read as Tan and
       started this whole correction. Digitizing is included and the threads are matched
       to the artwork, so that is what the customer is told. */
    tnote += (tnote ? '<br>' : '') +
      'Your logo is shown in its own colors on both mats. Logo digitizing is included and ' +
      'we match the embroidery threads to your artwork.';
  }
  el('threadNote').innerHTML = tnote;
  if(el('threadReq').value !== S.threadRequest) el('threadReq').value = S.threadRequest;

  /* THE MATCHING PACKAGE COLOR READOUT IS GONE (Patrick, 2026-09-08): "Remove the
     entire section… do not replace it with more explanatory copy. The matching package
     concept should be visually obvious from the package itself." There is no #matchHint
     element to write to any more — do not add one back.

     The MATCHING RULE ITSELF IS UNCHANGED and is not a display concern: coordinate()
     still resolves S.hd from the Boarding Mat color and S.ink from the thread color,
     the finished-package preview paints both mats from those, and hdBgName() /
     hdInkName() still put the real chart cell and PMS number on the order in
     cartSummary(). What was deleted is the paragraph that explained it in words. */

  syncRefs();
}

/* ------------------------------------------------------------------ *
 * 14b. GALLERY REFERENCES + SPECIAL NOTES
 *      Patrick, items 12–16: a customer must be able to say "I like Boarding Mat #12"
 *      or "HD Mat #217", that reference has to survive every screen change, and it is a
 *      STYLE / COLOR / LAYOUT reference only — never an instruction to reuse another
 *      customer's artwork or vessel name.
 * ------------------------------------------------------------------ */
function refLabel(kind, n){ return (kind==='board' ? 'Boarding Mat #' : 'HD Mat #') + n; }
/* Pressing REFERENCE THIS DESIGN on the mat that is already referenced clears it. That
   used to be done with the × on the reference chips; the chips went with the 2026-09-08
   cleanup, so the gallery button itself has to be the way back out. */
function setRef(kind, n){
  if(n !== null && (kind === 'board' ? S.refBoard : S.refHd) === n) n = null;
  if(kind === 'board'){ S.refBoard = n; paintBoardGal(); }
  else { S.refHd = n; paintHd(); }
  buildUI(); syncChrome();
}
/* parseRef() and refInRange() parsed a typed gallery number. There is no field to type
   one into any more — the gallery's own REFERENCE THIS DESIGN button is the only way in,
   and it passes a real number straight to setRef(). */

/* CLEANUP 2026-09-08 (Patrick), in two passes: first the INSPIRATION REFERENCES block and
   the Boarding Mat panel's reference input went, then the whole per-mat editing step took
   the HD panel's input with it. There is NO reference field on the page now — a gallery
   number is picked by pressing REFERENCE THIS DESIGN on the gallery image itself, and it
   still travels with the order. All that is left to sync here is the notes counter.
   Do not reintroduce refBoardIn / refHdIn / refChips / refNone. */
function syncRefs(){
  /* The counter appears only once there is something to count. It used to carry a
     standing "anything you type here stays with your design as you keep working" line,
     which is small print on an empty field — deleted with the rest of it 2026-09-08. */
  el('notesCount').textContent = S.notes.trim()
    ? S.notes.trim().length + ' of 1200 characters — saved with your design.'
    : '';

  /* #refState — "No gallery example chosen yet — this is optional." — was DELETED with
     the whole GALLERY EXAMPLE YOU LIKE block on 2026-09-08. The gallery tile's own
     REFERENCE THIS DESIGN button still shows which mat is picked (it goes gold), and
     the number still rides on the order through cartSummary(). Do not reintroduce a
     status line above the galleries. */
}

/* THE PRINTED CHART IS NO LONGER A SELECTOR.
   Patrick, 2026-09-08: the HD Mat Background Color chart and the HD Print / Ink Color
   chart were both removed from the page — the package is a matching set, so there is
   nothing on the HD panel to pick. The 150-cell chart data (HD_COLORS / HD_BY_CELL) is
   still what the mat is MADE from: coordinate() resolves the Boarding Mat color and the
   thread color onto real chart cells, and those cells travel with the order. What was
   deleted is the two grids, their readouts, their hover-to-enlarge and their setters. */

/* ------------------------------------------------------------------ *
 * 15. GALLERIES
 * ------------------------------------------------------------------ */
var HD_GAL = [], BOARD_GAL = [];

/* BOARDING MAT GALLERY — numbered exactly like the HD wall (Patrick, 2026-09-08).
   The numbers come out of gallery-board.json, which build/make_board_gallery.py writes
   once and preserves on every re-run. Nothing here sorts, shuffles or renumbers, so
   "Boarding Mat #12" is the same photograph on every load, for every customer, forever. */
function paintBoardGal(){
  el('galBoard').innerHTML = BOARD_GAL.map(function(g,i){
    return '<figure>'+
      '<button class="shot" onclick="lbOpen(\'board\','+i+')" '+
        'aria-label="Boarding mat number '+g.n+' — '+g.c+', larger view">'+
        '<img loading="lazy" decoding="async" src="'+SF_BASE+'galb/'+g.t+'.jpg" '+
          'alt="BoatMat custom embroidered boarding mat #'+g.n+' — '+g.c+'">'+
        '<span class="seq">#'+g.n+'</span></button>'+
      '<figcaption>#'+g.n+' &middot; '+g.c+'</figcaption>'+
      '<button class="usebtn'+(S.refBoard===g.n?' on':'')+'" onclick="setRef(\'board\','+g.n+')">'+
        (S.refBoard===g.n ? 'Referenced ✓' : 'Reference this design')+'</button>'+
      '</figure>';
  }).join('');
  el('galBoardCount').textContent = BOARD_GAL.length
    ? BOARD_GAL.length + ' completed BoatMat boarding mats · numbered #' +
      BOARD_GAL[0].n + '–#' + BOARD_GAL[BOARD_GAL.length-1].n
    : 'gallery unavailable';
}

function buildGalleries(){
  fetch(SF_BASE+'gallery-board.json').then(function(r){ return r.json(); }).then(function(list){
    BOARD_GAL = list; paintBoardGal(); syncRefs();
  }).catch(function(){ el('galBoardCount').textContent = 'gallery unavailable'; });

  fetch(SF_BASE+'gallery-hd.json').then(function(r){ return r.json(); }).then(function(list){
    HD_GAL = list;
    if(!list.length){ el('galHdCount').textContent = 'gallery unavailable'; return; }
    el('galHdCount').textContent = list.length+' completed BoatMat HD DigiPrint™ mats · '+
      'numbered #'+list[0].n+'–#'+list[list.length-1].n;
    galShown = Math.min(GAL_PAGE, list.length);
    paintHd(); syncRefs();
  }).catch(function(){
    el('galHdCount').textContent = 'gallery unavailable';
  });
}
/* All 337 tiles are in the manifest and every one is reachable; they are painted in
   pages so a phone is not asked to build a 27,000px-tall grid on first paint. The
   numbers are the manifest's own, so they never shift as more are revealed. */
var GAL_PAGE = 72, galShown = 0;
function paintHd(){
  var list = HD_GAL.slice(0, galShown);
  el('galHd').innerHTML = list.map(function(g,i){
    return '<div class="tile">'+
      '<button class="shot" onclick="lbOpen(\'hd\','+i+')" '+
        'aria-label="HD DigiPrint mat number '+g.n+', larger view">'+
        '<img loading="lazy" decoding="async" src="'+SF_BASE+'gal/'+g.t+'.jpg" alt="BoatMat HD DigiPrint mat #'+g.n+'">'+
      '</button>'+
      '<span class="seq">#'+g.n+'</span>'+
      '<button class="usebtn'+(S.refHd===g.n?' on':'')+'" onclick="setRef(\'hd\','+g.n+')">'+
        (S.refHd===g.n ? 'Referenced ✓' : 'Reference this design')+'</button>'+
      '</div>';
  }).join('');
  var left = HD_GAL.length - galShown;
  var lbl = left>0 ? ('Show '+Math.min(GAL_PAGE,left)+' more  ('+galShown+' of '+HD_GAL.length+')')
                   : ('All '+HD_GAL.length+' shown');
  ['galMore','galMore2'].forEach(function(id){
    var b = el(id); if(!b) return;
    b.textContent = lbl; b.disabled = left<=0; b.style.opacity = left>0 ? 1 : .4;
  });
  var a = el('galAll'); if(a){ a.textContent = 'Show all '+HD_GAL.length; a.hidden = left<=0; }
}
function galMore(){ galShown = Math.min(HD_GAL.length, galShown + GAL_PAGE); paintHd(); }
function galAll(){ galShown = HD_GAL.length; paintHd(); }
function galGoto(n){
  var i = -1;
  for(var k=0;k<HD_GAL.length;k++) if(HD_GAL[k].n === n){ i = k; break; }
  if(i < 0) return false;
  if(i >= galShown){ galShown = Math.min(HD_GAL.length, i + GAL_PAGE); paintHd(); }
  lbOpen('hd', i);
  return true;
}
function galBoardGoto(n){
  for(var k=0;k<BOARD_GAL.length;k++) if(BOARD_GAL[k].n === n){ lbOpen('board', k); return true; }
  return false;
}
/* ------------------------------------------------------------------ *
 * GALLERY OPEN / CLOSE
 * Patrick, 2026-09-08: both walls closed on arrival, one button each, each opening its
 * own wall, neither opening the other, and a clean way back out. The button IS the way
 * out — its label flips to HIDE — with a Close control at the foot of the wall as well,
 * because the HD wall is 337 photographs long and scrolling back to the top to shut it
 * is not "clean". No copy was added to explain any of this.
 * ------------------------------------------------------------------ */
var GAL_OPEN = { board:false, hd:false };
var GAL_LABEL = {
  board:['View Boarding Mat Gallery', 'Hide Boarding Mat Gallery'],
  hd:['View HD DigiPrint\u2122 Mat Gallery', 'Hide HD DigiPrint\u2122 Mat Gallery']
};
function setGallery(kind, open){
  var wrap = el(kind === 'board' ? 'galWrapBoard' : 'galWrapHd');
  var btn  = el(kind === 'board' ? 'btnGalBoard'  : 'btnGalHd');
  if(!wrap || !btn) return;
  GAL_OPEN[kind] = !!open;
  wrap.hidden = !open;
  btn.classList.toggle('on', !!open);
  btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  btn.textContent = GAL_LABEL[kind][open ? 1 : 0];
}
/* independent by design — opening one never touches the other */
function toggleGallery(kind){
  var open = !GAL_OPEN[kind];
  setGallery(kind, open);
  if(open){
    var btn = el(kind === 'board' ? 'btnGalBoard' : 'btnGalHd');
    if(btn && btn.scrollIntoView) btn.scrollIntoView({block:'start', behavior:'smooth'});
  }
}
function openGallery(kind){ if(!GAL_OPEN[kind]) setGallery(kind, true); }

/* ONE lightbox serves both walls, so the larger view and the REFERENCE THIS DESIGN
   action behave identically whichever gallery the customer is in. */
var lbIdx = 0, lbKind = 'hd';
function lbList(){ return lbKind==='board' ? BOARD_GAL : HD_GAL; }
function lbOpen(kind, i){
  lbKind = kind; lbIdx = i;
  var g = lbList()[i]; if(!g) return;
  el('lbImg').src = kind==='board'
    ? SF_BASE+'board/' + g.t + '.jpg'
    : HD_GAL_FULL + g.t + '.' + (g.e || 'jpg');            /* the wall is not all .jpg */
  el('lbImg').alt = (kind==='board' ? 'BoatMat boarding mat #' : 'BoatMat HD DigiPrint mat #') + g.n;
  el('lbCap').textContent = (kind==='board' ? 'Boarding Mat #' : 'HD Mat #') + g.n +
    (g.c ? '  ·  ' + g.c : '');
  syncLbUse();
  el('lb').classList.add('open');
}
function syncLbUse(){
  var g = lbList()[lbIdx]; if(!g) return;
  var on = (lbKind==='board' ? S.refBoard : S.refHd) === g.n;
  el('lbUse').textContent = on ? 'Referenced ✓' : 'Reference this design';
  el('lbUse').style.opacity = on ? .75 : 1;
}
/* Storing a gallery number stores THE NUMBER. It never copies the vessel name, the
   logo or any artwork out of another customer's mat (Patrick, item 16). */
function lbUseRef(e){
  e.stopPropagation();
  var g = lbList()[lbIdx]; if(!g) return;
  setRef(lbKind==='board' ? 'board' : 'hd', g.n);
  syncLbUse();
}
function lbStep(e, d){
  e.stopPropagation();
  var L = lbList();
  lbOpen(lbKind, (lbIdx + d + L.length) % L.length);
}

/* ------------------------------------------------------------------ *
 * 16. HANDLERS
 * ------------------------------------------------------------------ */
function setPkg(k){
  S.pkg = k; S.boardW = pkgOf(k).board;      /* the HD mat never changes size */
  buildUI(); renderAll();
}
/* setEdit() is GONE — there are no EDIT BOARDING MAT / EDIT HD DIGIPRINT MAT tabs and no
   panels to switch between (Patrick, 2026-09-08). S.edit survives only as "the mat the
   customer last touched in the preview", which is what a pinch gesture scales. */
function setMode(m){ S.mode = m; buildUI(); renderAll(); }
function setFont(i){ S.font = FONTS[i]; buildUI(); renderAll(); }

/* ---- STEP 2 handlers ----------------------------------------------
   One color decision. The HD DigiPrint mat and its binding are coordinated to it, so
   the two products never read as unrelated. */
/* THE MATCHING RULE, in one function.
   Patrick, 2026-09-08: the package is a MATCHING set, so the customer does not pick an
   HD mat background and does not pick a print/ink color. Both chart boxes came off the
   page. The HD DigiPrint mat's background IS the Boarding Mat color, and its print IS
   the embroidery thread color — mapped onto the nearest cell of the real printed chart,
   so what production reads is still a genuine chart code and PMS number, never an
   invented hex. */
function nearestCell(hex){
  var t = hex2rgb(hex), best = null, bd = Infinity;
  HD_COLORS.forEach(function(c){
    var d = dist2(t, hex2rgb(c.h));
    if(d < bd){ bd = d; best = c; }
  });
  return best;
}
function coordinate(){
  S.hd  = HD_BY_CELL[S.color.hdCell];
  S.ink = nearestCell(S.thread.hex);
  inkKey = '';
}
function setColor(i){
  S.color = PACK_COLORS[i]; S.specialty = false; coordinate();
  buildUI(); renderAll();
}
/* A non-stock Sunbrella color: the customer names it, we source it, +$35 per Boarding
   Mat. The preview stays on the stocked color they last chose, and says so — inventing
   a rendering of a fabric we have not seen would be worse than admitting we cannot. */
function setSpecialty(){
  S.specialty = true;
  buildUI(); renderAll();
  var f = el('specName'); if(f) f.focus();
}
/* One thread decision drives both mats: the lettering is sewn in it on the Boarding Mat
   and printed in it on the HD DigiPrint Mat. That is what "matching" means here. */
function setThread(i){ S.thread = THREADS[i]; coordinate(); buildUI(); renderAll(); }
/* resetArt() went with the per-mat editors — nothing calls it and there is no button for
   it. A new logo still re-initialises both mats to the 75% default (see the upload
   handler), which is the only reset the flow needs now. */

/* ------------------------------------------------------------------ *
 * 17. POINTER INTERACTION — drag to move, wheel / pinch to size
 * ------------------------------------------------------------------ */
/* Which mat is under the pointer? With the view tabs gone there is no "current product"
   to guess at — the customer drags the mat they are looking at, and the boarding mat
   wins where the two overlap because it is the one drawn on top. */
function pickSurface(sx, sy){
  var order = [['board', el('sfTop'), B_PPI], ['dock', el('sfDock'), D_PPI]];
  for(var i=0;i<order.length;i++){
    var cv = order[i][1];
    if(!cv || !cv._H) continue;
    var p = applyH(invH(cv._H), sx, sy);
    if(p[0] >= 0 && p[1] >= 0 && p[0] <= cv.width && p[1] <= cv.height)
      return { which:order[i][0], ix:p[0]/order[i][2], iy:p[1]/order[i][2] };
  }
  return null;
}
/* sceneToDesign() is gone with the flat proof editors it fed — pickSurface() above
   already resolves a scene point to a mat and to inches, with no "current product" to
   guess at. */
function setArtFromPoint(which, ix, iy){
  var box = artBox(which); if(!box) return;
  var sf = safeOf(which);
  var insX = which==='board' ? B_INSET_X : D_INSET;
  var insY = which==='board' ? B_INSET_Y : D_INSET;
  var freeX = Math.max(1e-6, sf.w - box.rw), freeY = Math.max(1e-6, sf.h - box.rh);
  var a = S.art[which];
  a.xN = clamp((ix - insX - box.rw/2)/freeX, 0, 1);
  a.yN = clamp((iy - insY - box.rh/2)/freeY, 0, 1);
}
function clamp(v,a,b){ return v<a?a:(v>b?b:v); }

var drag = null;
function bindStage(){
  var hit = el('hit');
  function scenePt(e){
    var k = el('stage')._k || 1, r = el('stage').getBoundingClientRect();
    return pickSurface((e.clientX-r.left)/k, (e.clientY-r.top)/k + SCENE_CROP_TOP);
  }
  hit.addEventListener('pointerdown', function(e){
    var d = scenePt(e); if(!d) return;
    drag = {id:e.pointerId, which:d.which};
    S.edit = d.which;
    hit.setPointerCapture(e.pointerId);
    setArtFromPoint(d.which, d.ix, d.iy); buildUI(); renderAll();
  });
  hit.addEventListener('pointermove', function(e){
    if(!drag || drag.id!==e.pointerId) return;
    var d = scenePt(e); if(!d || d.which!==drag.which) return;
    setArtFromPoint(drag.which, d.ix, d.iy); renderSoon();
  });
  ['pointerup','pointercancel'].forEach(function(ev){
    hit.addEventListener(ev, function(){ drag=null; });
  });
  hit.addEventListener('wheel', function(e){
    e.preventDefault();
    var d = scenePt(e); if(!d) return;
    S.edit = d.which;
    nudgeScale(d.which, e.deltaY>0 ? -0.03 : 0.03);
  }, {passive:false});

  /* The cvBoard / cvDock pointer bindings went with the flat proof editors — the finished
     package preview is the only surface the customer touches now. */

  /* pinch to size */
  var pts = {};
  ['hit'].forEach(function(id){
    var n = el(id);
    n.addEventListener('pointerdown', function(e){ pts[e.pointerId]=[e.clientX,e.clientY]; });
    n.addEventListener('pointermove', function(e){
      if(!(e.pointerId in pts)) return;
      pts[e.pointerId]=[e.clientX,e.clientY];
      var k = Object.keys(pts);
      if(k.length===2){
        var a=pts[k[0]], b=pts[k[1]];
        var d = Math.hypot(a[0]-b[0], a[1]-b[1]);
        if(n._pd) nudgeScale(S.edit, (d-n._pd)*0.0016);
        n._pd = d; drag=null;
      }
    });
    ['pointerup','pointercancel'].forEach(function(ev){
      n.addEventListener(ev, function(e){ delete pts[e.pointerId]; n._pd=null; });
    });
  });

  var gj = el('galJump');
  if(gj) gj.addEventListener('keydown', function(e){
    if(e.key !== 'Enter') return;
    var n = parseInt(this.value, 10);
    if(n > 0 && !galGoto(n)) this.value = '';
  });
  var gb = el('galBoardJump');
  if(gb) gb.addEventListener('keydown', function(e){
    if(e.key !== 'Enter') return;
    var n = parseInt(this.value, 10);
    if(n > 0 && !galBoardGoto(n)) this.value = '';
  });
  el('lb').addEventListener('click', function(){ this.classList.remove('open'); });
  document.addEventListener('keydown', function(e){
    if(!el('lb').classList.contains('open')) return;
    var L = lbList();
    if(e.key==='Escape') el('lb').classList.remove('open');
    if(e.key==='ArrowLeft')  lbOpen(lbKind, (lbIdx-1+L.length)%L.length);
    if(e.key==='ArrowRight') lbOpen(lbKind, (lbIdx+1)%L.length);
  });
}
/* dvMove() mapped a pointer onto a flat proof canvas. Those canvases are gone. */
function nudgeScale(which, d){
  S.art[which].sN = clamp(S.art[which].sN + d, 0.12, 1.0);
  buildUI(); renderSoon();
}

/* ------------------------------------------------------------------ *
 * 18. INPUT WIRING
 * ------------------------------------------------------------------ */
function wire(){
  /* ONE vessel name and ONE logo, asked for once in Step 3 and used on both products. */
  el('vessel').addEventListener('input', function(){
    S.vessel = this.value;
    renderAll();
  });
  el('specName').addEventListener('input', function(){
    S.specialtyName = this.value;
    syncChrome();
  });

  /* ---- ORDER INFORMATION THAT MUST NOT DISAPPEAR (Patrick, items 7, 12–15) ----
     All of it lives in S, and nothing that switches package, view, product or gallery
     rebuilds these inputs from scratch — buildUI() only ever writes a value back when
     it differs, and never while the field has focus. */
  el('threadReq').addEventListener('input', function(){
    S.threadRequest = this.value;
    syncChrome();
  });
  el('specialNotes').addEventListener('input', function(){
    S.notes = this.value;
    syncRefs(); syncChrome();
  });
  /* No reference input and no artwork size sliders — both went with the per-mat editing
     step (Patrick, 2026-09-08). A gallery number is picked on the gallery image itself;
     artwork is dragged and scrolled/pinched on the finished-package preview. */

  el('logoFile').addEventListener('change', function(){
    var f = this.files && this.files[0]; if(!f) return;
    el('upStat').classList.add('on');
    el('upTxt').textContent = 'Reading '+f.name+'…';
    var fr = new FileReader();
    fr.onload = function(){
      var im = new Image();
      im.onload = function(){
        S.logo.img = im; S.logo.ok = true; S.logo.name = f.name;
        S.logo.palette = extractPalette(im);
        threadKey = ''; inkKey = '';
        if(S.mode==='text') S.mode = 'logo';
        /* THE RULE: a new logo re-initialises BOTH products to 75% of their own width */
        S.art.board = newArt(); S.art.dock = newArt();
        el('upTh').src = fr.result;
        el('upTxt').textContent = f.name+' — ready';
        buildUI(); renderAll();
      };
      im.onerror = function(){
        el('upTxt').textContent = 'Could not preview that file — try PNG, JPG, SVG or WEBP.';
      };
      im.src = fr.result;
    };
    fr.readAsDataURL(f);
  });

  /* THE HEADER'S OWN BEHAVIOR IS NO LONGER OURS TO WRITE (2026-09-08). The SHOP
     dropdown and the mobile drawer now run on BoatMat.com's own scripts, which ship in
     the page with the markup they belong to — toggleBmMenu() and the mob-drawer IIFE,
     both lifted verbatim from the live site. Re-implementing them here is exactly how a
     copied header drifts away from the real one. Do not add nav code back to app.js. */

  var rt;
  window.addEventListener('resize', function(){
    clearTimeout(rt);
    rt = setTimeout(function(){ fitScene(); fitHeading(); renderAll(); }, 90);
  });
}

/* ------------------------------------------------------------------ *
 * 19. BOOT — the 30″ package opens first
 * ------------------------------------------------------------------ */
(function init(){
  /* Both HD colors are set by coordinate(): the mat from the Boarding Mat color, the
     print from the embroidery thread. Nothing here seeds an ink the customer can keep. */
  /* BOTH PRODUCTS OPEN BLACK (Patrick, 2026-09-08) — a matching black pair, so the
     package reads as coordinated the moment the page loads. */
  S.color = PACK_COLORS.filter(function(c){ return c.k === 'black'; })[0] || PACK_COLORS[0];
  coordinate();
  S.pkg = '30'; S.boardW = 30;             /* STANDARD is the default package */
  buildUI(); wire(); bindStage(); buildGalleries();

  fetch(SF_BASE+'scene-cam.json').then(function(r){ return r.json(); }).then(function(j){
    CAM = j; WLD = j.world; IMG_W = j.img[0]; IMG_H = j.img[1];
    /* the hero crop comes from the camera build, so it can never go stale */
    if(j.crop){ SCENE_CROP_TOP = j.crop[0]; SCENE_VIS_H = j.crop[1]; }
    fitScene();
    done();                          /* releases the initial `pending` of 1 */
  }).catch(function(){ done(); });

  /* fitHeading() must run AFTER the webfont lands — measured against the fallback face
     it would shrink the heading for a width that stops being true a moment later. */
  document.fonts && document.fonts.ready.then(function(){ fitHeading(); if(READY) renderAll(); });
  setTimeout(function(){ fitScene(); fitHeading(); if(READY) renderAll(); }, 120);
})();


/* =====================================================================
   PRODUCTION ADD TO CART — appended to the theme build only.

   The prototype's addToCart() renders a "CHECKOUT IS NOT CONNECTED" panel. Inside the
   theme it is replaced by this, which puts the real package in the real Shopify cart.

   WHY A REAL FORM POST AND NOT fetch('/cart/add.js'):
   the customer's uploaded artwork has to reach the order. Shopify hosts line-item files
   only when they arrive as a genuine multipart form field (properties[Artwork] on a real
   <input type="file">) — the AJAX endpoint cannot carry a file. So this builds a hidden
   form, MOVES the customer's own file input into it so the actual File goes along, and
   submits. Jessica gets a download link on the order line instead of a filename she
   cannot open.

   PRICE AUTHORITY: the variant id decides the price, server-side. Nothing here sends an
   amount. The +$35 specialty color is a second variant, not a number typed by the page.

   PROPERTY NAMING: keys the customer should see are plain; keys that are production-only
   start with an underscore, which Shopify hides from the customer everywhere while still
   storing them on the order. That is the same convention the prototype panel used.
   ===================================================================== */
(function () {
  if (!window.SPORTFISH_VARIANTS) return;          /* prototype: leave addToCart alone */

  /* One id per design, so a proof, an email and an order line can all be tied together
     without anyone reconstructing the customer's session. */
  function designId() {
    var d = new Date();
    var p = function (n) { return (n < 10 ? '0' : '') + n; };
    var stamp = d.getFullYear() + p(d.getMonth() + 1) + p(d.getDate()) + '-' +
                p(d.getHours()) + p(d.getMinutes()) + p(d.getSeconds());
    var rnd = Math.random().toString(36).slice(2, 6).toUpperCase();
    return 'SF-' + stamp + '-' + rnd;
  }

  function variantFor() {
    var v = window.SPORTFISH_VARIANTS[S.pkg];
    if (!v) return null;
    return S.specialty ? v.specialty : v.stocked;
  }

  window.addToCart = function () {
    var variant = variantFor();
    var msg = el('cartMsg');
    if (!variant) {
      if (msg) { msg.hidden = false; msg.innerHTML = '<b>Sorry — that package could not be added.</b> Please call 321.751.4636.'; }
      return;
    }

    var s = cartSummary(), ps = prodSpec(), id = designId();
    var btn = el('addCart');
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    var form = document.createElement('form');
    form.method = 'post';
    form.action = window.SPORTFISH_CART_URL_FORM || '/cart/add';
    form.enctype = 'multipart/form-data';
    form.style.display = 'none';

    function hidden(name, value) {
      var i = document.createElement('input');
      i.type = 'hidden'; i.name = name; i.value = value;
      form.appendChild(i);
    }
    hidden('id', variant);
    hidden('quantity', '1');

    /* everything the customer chose, in the words the page used */
    s.rows.forEach(function (r) { hidden('properties[' + r[0] + ']', r[1]); });

    /* production-only, hidden from the customer by Shopify's underscore convention */
    hidden('properties[_design_id]', id);
    hidden('properties[_boarding_mat_width_in]', String(S.boardW));
    hidden('properties[_dock_mat_size_in]', DOCK_MAT[0] + ' x ' + DOCK_MAT[1]);
    hidden('properties[_hd_chart_cell]', ps.hdCell);
    hidden('properties[_hd_chart_pms]', ps.hdPms);
    hidden('properties[_ink_chart_cell]', ps.inkCell);
    hidden('properties[_ink_chart_pms]', ps.inkPms);
    hidden('properties[_sunbrella_colorway]', (S.color && S.color.seamark) || '');
    hidden('properties[_lettering_font]', S.font ? S.font.n : '');
    hidden('properties[_design_mode]', S.mode);
    if (S.specialty) hidden('properties[_specialty_color_requested]', S.specialtyName || '');
    if (S.refBoard) hidden('properties[_ref_boarding_mat]', String(S.refBoard));
    if (S.refHd) hidden('properties[_ref_hd_mat]', String(S.refHd));
    hidden('properties[_artwork_placement]', JSON.stringify(S.art || {}));
    hidden('properties[_designed_at]', new Date().toISOString());
    hidden('properties[_design_station]', 'sportfish-packages');

    /* PROOF CONTROL: a paid order does not mean production may start. This is the flag
       the office workflow reads — nothing is released until artwork is approved. */
    hidden('properties[_proof_status]', 'AWAITING PROOF APPROVAL');

    /* The artwork itself. Moving the real input carries the real File; if the customer
       did not upload one (vessel-name-only designs) the field is simply absent. */
    var file = document.getElementById('logoFile');
    if (file && file.files && file.files.length) {
      /* THE NAME MATTERS, and it is not cosmetic. BMOS's order sync only lifts an
         uploaded file into Jessica's production view when the line-item property is
         named like "artwork file" (orders/service.js: ARTWORK_PROPERTY_RE = /artwork
         file/i), and the live BoatMat configurator has always called it "■ Artwork
         File". Named anything else the file still reaches the Shopify order but never
         becomes a customer_artwork asset in BMOS — so it would look fine in Shopify and
         be missing exactly where production looks for it. Same name, same behavior as
         every other BoatMat order. */
      file.setAttribute('name', 'properties[\u25a0 Artwork File]');
      form.appendChild(file);
    }

    document.body.appendChild(form);
    form.submit();
  };
})();
